export default{
    "id": "İD",
    "dashboard": "Gösterge Paneli",
    "warning": "Uyarı",
    "users": "Kullanıcılar",
    "farms": "Çiftlikler",
    "animals": "Hayvanlar",
    "action": "Aksiyon",
    "actionList": "Aksiyon listesi",
    "drugInventory": "İlaç Envanteri",
    "inseminatorStatistics": "Tohumlama İstatistikleri",
    "organizationNTR": "Organizasyon NTR'si",
    "genotypePerformance": "Genotip Performansı",
    "semenAutomation": "Semen Otomasyonu",
    "activityLogs": "Etkinlik Günlüğü",
    "username": "Kullanıcı adı",
    "title": "Başlık",
    "deactivated": "Devre dışı bırakıldı",
    "name": "İsim",
    "email": "E-posta",
    "emailAddress": "E-posta Adresi",
    "mobileNum": "Cep numarası",
    "emailOrMobile": "E-posta/Mobil",
    "role": "rol",
    "roles": "Roller",
    "department": "Departman",
    "status": "Durum",
    "pages": "Sayfalar",
    "departments": "Bölümler",
    "password": "Şifre",
    "cancel": "İptal etmek",
    "submit": "Göndermek",
    "error": "hata",
    "success": "başarı",
    "Browse": "Araştır",
    "orDropYourFileCsvXlsXlsxHere": "veya dosyanızı (CSV, XLS, XLSx) buraya bırakın",
    "search": "Aramak",
    "apply": "Uygula",
    "select": "Seçme",
    "previous": "Öncesi",
    "mandatory": "Zorunlu",
    "dropYourFileHere": "veya dosyanızı (CSV, XLS, XLSx, PDF,Docx,PNG,JPEG) buraya bırakın",
    "restoreDefault": "Varsayılana döndür",
    "pending": "Askıda olması",
    "completed": "Tamamlanmış",
    "remove": "Kaldırmak",
    "update": "Güncelleme",
    "removeFile": "Dosyayı Kaldır",
    "uploadFile": "Dosya yükleme",
    "pleaseChoosePreferedLanguage": "Lütfen tercih ettiğiniz dili seçin",
    "edit": "Düzenlemek",
    "activate": "Etkinleştir",
    "deactivate": "Devre dışı bırakmak",
    "recievedOrders": "Alınan Siparişler",
    "chartRepresentation": "Grafik Gösterimi",
    "nameIsRequired": "İsim gerekli",
    "export": "İhracat",
    "noFilesAvailable": "DOSYA YOK",
    "selectDepartmentToshowRoles": "Rolleri göstermek için bir departman seçin",
    "selectDepartmentWithActiveRoles": "Aktif rollere sahip bir departman seçin",
    "nameCanContainOnlyAlphabets": "Ad yalnızca alfabe içerebilir",
    "nameMustBeLessThan15Chars": "Ad 30 karakterden az olmalıdır",
    "emailRequired": "Email gereklidir",
    "invalidEmailFormat": "Geçersiz e-posta formatı",
    "mobNumReq": "Cep telefonu numarası gerekli",
    "invalidMobFormat": "Geçersiz cep telefonu numarası biçimi.",
    "passwordRequired": "Şifre gereklidir",
    "departmentReq": "Departman gerekli",
    "roleReq": "rol gerekli",
    "unableToUpdate": "güncellenemiyor",
    "orignalName": "Orjinal isim",
    "uploadedDate": "Yükleme Tarihi",
    "fileName": "Dosya adı",
    "importNum": "İthalat Numarası",
    "languagePreferences": "Dil Tercihi",
    "pleaseTryAgainAfterSometime": "Lütfen bir süre sonra deneyin",
    "noChanges": "Değişiklik yok",
    "nothingchanged": "Hiçbirşey değişmedi",
    "pleaseChooseAnImageFile": "Lütfen bir resim dosyası seçin",
    "fileIsTooBigSelectUnder1MB": "Dosyanız çok büyük! ",
    "phoneShouldHave10Chars": "Telefon 10 karakterden oluşmalıdır",
    "onlyCSVAllowed": "Yalnızca CSV dosyasına izin verilir",
    "loadingPleaseWait": "Yükleniyor lütfen bekleyin",
    "manager": "müdür",
    "administrator": "yönetici",
    "Comingsoon": "Yakında gelecek",
    "totalAnimals": "Toplam Hayvanlar",
    "receivedOrders": "Alınan Siparişler",
    "drugs": "İlaçlar",
    "detailedAnalysis": "Detaylı analiz",
    "barGraphRepOfActiveUsersAndDeactivateUsers": "Aktif Kullanıcıların ve Devre Dışı Kullanıcıların Çubuk Grafik Temsili",
    "barGraphRepOfRegAnimalsVsFarm": "Çiftliğe Karşı Kayıtlı Hayvanların Çubuk Grafik Temsili",
    "roleNumber": "Rol Numarası",
    "roleName": "Rol ismi",
    "active": "Aktif",
    "inactive": "Etkin Değil",
    "admin": "yönetici",
    "addRole": "Rol Ekle",
    "addRoles": "Rol Ekle",
    "permissions": "İzinler",
    "sr": "Sr.",
    "moduleName": "Modül Adı",
    "view": "Görüş",
    "deptNo": "bölüm numarası",
    "selectByCategory": "Kategoriye göre seçin",
    "weeklyAnalytics": "Haftalık Analitik",
    "pregnancy": "Gebelik",
    "analytics": "Analitik",
    "calendar": "Takvim",
    "productName": "Ürün adı",
    "volumeSold": "Satılan Hacim",
    "recordPoints": "Kayıt Noktaları",
    "inStock": "Stokta var",
    "revenue": "Hasılat",
    "stockStatus": "Stok durumu",
    "barChart": "Grafik çubuğu",
    "lineChart": "Çizgi grafik",
    "indexReturns": "Endeks Getirileri",
    "chart": "Çizelge",
    "time": "zaman",
    "production": "Üretme",
    "customization": "özelleştirme",
    "recordsPerPage": "Sayfa başına kayıt",
    "noDataAvailable": "Veri Yok",
    "reporting": "Raporlama",
    "optional": "İsteğe bağlı",
    "note": "Not",
    "notes": "notlar",
    "date": "Tarih",
    "kG": "KİLOGRAM",
    "weight": "ağırlık",
    "type": "Tip",
    "lessthan3Month": "<3 Ay",
    "lessthan6Month": "<6 Ay",
    "lessthan7Month": "<7 Ay",
    "lastWeek": "Geçen hafta",
    "thisWeek": "Bu hafta",
    "lessthanOneYear": "<1 Yıl",
    "lessthanTwoYear": "<2 Yıl",
    "lessthanThreeYear": "<3 Yıl",
    "lessthanFourYear": "<4 Yıl",
    "yes": "Evet",
    "no": "HAYIR",
    "of": "ile ilgili",
    "notSpecified": "Belirtilmemiş",
    "days": "günler",
    "day": "gün",
    "aDay": "bir gün",
    "years": "yıl",
    "year": "yıl",
    "unit": "birim",
    "units": "Birimler",
    "to": "ile",
    "profile": "Profil",
    "logOut": "Çıkış Yap",
    "Unit": "Birim",
    "otherSettings": "Diğer ayarlar",
    "somethingWentWrong": "bir şeyler yanlış gitti.",
    "toDo": "Yapmak",
    "loadingData": "Veri yükleniyor...",
    "taskNumber": "Görev Numarası",
    "taskName": "Görev adı",
    "startDate": "Başlangıç ​​tarihi",
    "dueDate": "Bitiş tarihi",
    "reason": "Sebep",
    "quantity": "Miktar",
    "cost": "Maliyet",
    "noRecordFound": "Kayıt Bulunamadı",
    "dailyUpdates": "Günlük Güncellemeler",
    "weeklyUpdates": "Haftalık Güncellemeler",
    "moduleAccessed": "Modüle Erişildi",
    "typesOfAccess": "Erişim Türleri",
    "userId": "Kullanıcı kimliği",
    "lastLogin": "Son giriş",
    "terminalID": "Terminal Kimliği",
    "geographicalAccessPoint": "Coğrafi Erişim Noktası",
    "iPAddress": "IP adresi",
    "fileAccessed": "Erişilen Dosya",
    "functionAccessed": "Erişilen İşlev",
    "webPageURL": "Web Sayfası URL'si",
    "accessType": "Erişim türü",
    "unsuccessfulLoginAttempts": "Başarısız Giriş Denemeleri",
    "customerAddress": "Müşteri adresi",
    "orderdate": "Sipariş tarihi",
    "postageDate": "posta tarihi",
    "postID": "Posta kimliği",
    "packingTechnician": "Paketleme Teknisyeni",
    "packingTechnicia": "Paketleme Tekniği",
    "packEdit": "Paket Düzenleme",
    "batchNumber": "parti numarası",
    "collectionTechnician": "Tahsilat Teknisyeni",
    "collectionTechnicia": "Toplama Tekniği",
    "preparationTechnicia": "Hazırlık Teknikleri",
    "preparationTechnician": "Hazırlık Teknisyeni",
    "approvedManually": "Manuel Olarak Onaylandı",
    "researcher": "Araştırmacı",
    "dateOfApproval": "Onay tarihi",
    "approvalEdit": "Onay Düzenleme",
    "searchByAllExceptDate": "Tarih Hariç Tümüne Göre Ara",
    "approval": "Onay",
    "collection": "Toplamak",
    "postage": "posta ücreti",
    "pack": "Ambalaj",
    "straws": "payet",
    "createdAt": "oluşturuldu",
    "sireID": "Efendi Kimliği",
    "economicIndexValue": "Ekonomik Endeks Değeri",
    "latestCollectionDate": "Son Toplama Tarihi",
    "locationId": "Konum Kimliği",
    "lastUpdated": "Son güncelleme",
    "print": "Yazdır",
    "save": "Kaydetmek",
    "tax": "Vergi",
    "phoneNo": "Telefon yok",
    "exportAsPDF": "PDF olarak dışa aktar",
    "statusUpdated": "Durum Güncellendi",
    "statusNotUpdated": "Durum Güncellenmedi",
    "inProgress": "Devam etmekte",
    "assignedTo": "Atandı",
    "taskId": "görev kimliği",
    "createdDate": "Oluşturulma tarihi",
    "numberOfAnimals": "Hayvan Sayısı",
    "healthRecordSubmittedSuccess": "Sağlık Kaydı başarıyla gönderildi",
    "healthRecordSubmitted": "Sağlık Kaydı Gönderildi.",
    "InseminationRecordSubmittedSuccesful": "Tohumlama Kaydı başarıyla gönderildi",
    "inseminationRecordSubmitted": "Tohumlama Kaydı Gönderildi.",
    "actionListDailyTask": "Eylem Listesi - Günlük Görev",
    "sinceLastYear": "Geçen yıldan beri",
    "sinceLastQuarter": "Son Çeyrekten Beri",
    "sinceLastMonth": "Geçen aydan beri",
    "sinceLastWeek": "Geçen haftadan beri",
    "drugWithdrawPeriod": "İlaç Bırakma Dönemi",
    "diagnosisName": "Teşhis Adı",
    "animalWithNoGenetype": "Bu hayvanın kayıtlı herhangi bir Genotip verisi yok. ",
    "nameOfPreviousOwner": "Önceki Sahibin Adı",
    "avatarSize": "Avatar boyutu 1 MB'tan küçük olmalıdır!",
    "testDestination": "Test Hedefi",
    "animalNotAdded": "Hayvan Eklenmedi",
    "registerationSuccessful": "Kayıt başarılı",
    "backToAnimalList": "Hayvan Listesine Geri Dön",
    "addAnotherAnimal": "Başka bir Hayvan ekle",
    "animalDetailsUpdated": "Hayvan ayrıntıları başarıyla güncellendi",
    "animalUpdatedSuccessfully": "Hayvan Başarıyla Güncellendi",
    "animalNotUpdated": "Hayvan Güncellenmedi",
    "notMember": "Üye değil?",
    "requestAccess": "Erişim talep etmek",
    "typePassword": "Lütfen şifreyi yazınız.",
    "minChars": "en az 6 karakter",
    "typeConfirmPassword": "parolayı onayla yazın",
    "passConfig": "Parola onayı eşleşmiyor.",
    "invalidEmailMobile": "Geçersiz e-posta/mobil biçim",
    "passwordNotEmpty": "Şifre boş olamaz",
    "passwordLength": "Şifre uzunluğu 8 karakterden az olamaz",
    "cityVillage": "Şehir / Köy",
    "districtRegion": "İlçe / Bölge",
    "alreadyHaveAnAccount": "Zaten bir hesabınız var mı?",
    "genetypeUpdated": "GenoType Güncellendi",
    "genetypeNotUpdated": "GenoType Güncellenmedi",
    "sellTrade": "Satış/Ticaret",
    "milkingDevon": "Satılık Sağım Devon Damızlık Damızlık",
    "detailedDescription": "Detaylı Açıklama",
    "longPara": "American Milking Devon Bulls düveleri ve inekleri. ",
    "contactSeller": "Satıcıyla iletişime geç",
    "enterListingTitle": "İlan Başlığını Girin",
    "livestocktype": "Hayvan Türü",
    "uploadImage": "Bir görüntü yükle",
    "mobilePhone": "Cep telefonu numarası",
    "myLivestock": "Hayvanlarım",
    "livestockObservations": "Hayvancılık Gözlemleri",
    "selectFromRegisteredAnimals": "Kayıtlı Hayvanlar Listesinden Seçin",
    "selectOption": "Seçenek Seçin",
    "selectTypeObservation": "Gözlem Türünü Seçin",
    "attachVeteinaryDocument": "Veteriner Belgesini Ekleyin",
    "addsensorReading": "Sensör Okuması Ekle",
    "myDocument": "Benim dökümanlarım",
    "enterAKeyword": "Bir Anahtar Kelime Girin",
    "documentType": "Belge Türü",
    "registerEditLivestock": "Çiftlik Hayvanlarını Kaydet/Düzenle",
    "editLivestockProfile": "Çiftlik Hayvanı Profilini Düzenle",
    "copy": "kopyala",
    "dateOfRegister": "Kayıt Tarihi",
    "livestockType": "Hayvan Türü",
    "registerNewLivestock": "Yeni Canlı Hayvan Kaydı",
    "enterUniqueTag": "Benzersiz Etiket Girin",
    "color": "Renk",
    "gender": "Cinsiyet",
    "male": "Erkek",
    "female": "Dişi",
    "damm": "Baraj",
    "siree": "Efendim",
    "dateOfSaleAuction": "Satış/Müzayede Satış Tarihi",
    "auctionRecord": "Ölüm Listesi Müzayede Kaydı",
    "distinguishingFeatures": "Ayırt edici özellikler",
    "keywordListing": "Anahtar Kelime veya İlan Kimliği",
    "adType": "Reklam Türü",
    "activeListingFund": "1 Aktif İlan Bulundu",
    "setupSensors": "Sensörleri Kur",
    "serialNumber": "Seri numarası",
    "sensorLocation": "Sensör Konumu",
    "sensorType": "Sensör Tipi",
    "installationDate": "Kurulum tarihi",
    "ExpirationDate": "Son kullanma tarihi",
    "addGeo": "Coğrafi Konum Ekle",
    "addMoreSensors": "Daha Fazla Sensör Ekleyin",
    "trackAndTrace": "Takip ve izleme",
    "createNewShipment": "Yeni Gönderi Oluştur",
    "workflowReference": "İş Akışı Referansı",
    "invoiceDate": "Fatura tarihi",
    "trackShipment": "Gönderi takibi",
    "totalShipments": "Toplam Gönderiler",
    "activeShipment": "Aktif Gönderiler",
    "completedObjectives": "Tamamlanan Hedefler",
    "processedPayments": "İşlenen Ödemeler",
    "pointOfDestination": "Varış Noktası",
    "sellerInformation": "Satıcı bilgisi",
    "selectSellerConsignor": "Satıcı/Gönderici Seçin",
    "pointOfOrigin": "Menşe Noktası",
    "buyerInfo": "Alıcı Bilgileri",
    "selectBuyerConsignor": "Alıcı/Gönderen Seçin",
    "addSensorTriggers": "Sensör Tetikleyicileri Ekle",
    "processPayments": "Ödemeleri İşle",
    "defineShippingContract": "Sevkiyat Sözleşmesini Tanımla",
    "addDigitize": "Eklemek",
    "currentlyOnFarm": "Şu anda Çiftlikte",
    "addSire": "efendim ekle",
    "addApproval": "Onay Ekle",
    "addCollection": "Koleksiyon Ekle",
    "addStraws": "Payet Ekle",
    "addPack": "Paket Ekle",
    "addPostage": "Posta ücreti ekle",
    "searchBySire": "Efendiye Göre Ara",
    "anyDataChangeMightBeLost": "Herhangi bir veri değişikliği kaybolabilir",
    "wouldYouLikeToSaveOrWantToLeaveWithoutSaving": "Kaydetmek mi yoksa kaydetmeden çıkmak mı istiyorsunuz?",
    "leave": "Ayrılmak",
    "stay": "Kalmak",
    "animalFarm": "Hayvan Çiftliği",
    "animalFarmH": "Hayvan Çiftliği",
    "animalOrigin": "Hayvan Kökeni",
    "animalOriginH": "Hayvan Kökeni",
    "farmOfOrigin": "menşe çiftliği",
    "farmOfOriginH": "menşe çiftliği",
    "selectFarm": "Çiftlik Seç",
    "searchFarm": "Çiftlik Ara",
    "confirmation": "Onayla",
    "proceed": "İlerlemek",
    "ok": "TAMAM",
    "animal": {
      "tagH": "Etiket",
      "tagNumberH": "Etiket Numarası: Numaranın yanı sıra renk de ekleyebilirsiniz. ",
      "goveRegNoH": "Bir devlet kuruluşuna kayıt olurken verilen numara",
      "birthWeightH": "Buzağının Doğum Ağırlığı",
      "birthEaseH": "Çiftlik hayvanlarında doğum doğal bir süreçtir, ancak bazen barajın çiftçi/çoban yardımına ihtiyaç duyduğu doğum sorunları olabilir.",
      "birthFarmH": "Hayvan kökenli/doğum çiftliği.",
      "surrogateDamH": "Donör erkek ve donör dişiden alınan döllenmiş yumurtanın daha da geliştirilmesi için implante edildiği dişi ineğin kimliği.",
      "ownerH": "Bu, hayvanın sahibinin adıdır.",
      "damH": "Hayvanın dişi ebeveyninin/annesinin kimliği.",
      "sireH": "Hayvanın erkek ebeveyninin/babasının kimliği.",
      "breedH": "Bir cins, homojen bir görünüme (fenotip), homojen davranışa ve/veya onu aynı türün diğer organizmalarından ayıran diğer özelliklere sahip belirli bir evcil hayvan grubudur.",
      "conceptionMethodH": "Hayvanın nasıl gebe kaldığı.",
      "genderH": "Hayvanın cinsiyeti.",
      "dobH": "Hayvanın doğum tarihi.",
      "operatorH": "Bu hayvanın bilgilerini dolduran kişinin adı.",
      "removalFarmH": "Hayvan Kaldırılan Çiftlik ",
      "dateOfRemovalH": "Hayvan çıkarma tarihi",
      "destinationOfRemoval": "Kaldırılan hayvanın varış yeri",
      "reasonOfRemovalH": "Hayvanın uzaklaştırılma nedeni",
      "trackingNumberH": "Hayvan çıkarıldığında hayvana atanan numara",
      "brandH": "Marka-Sadece ineğin üzerine yakılan kalıcı bir işaret.",
      "tattoH": "Hayvan üzerine dövme.",
      "hornStatusH": "Hayvanın boynuzunun kesilip kesilmediği.",
      "animalOriginH": "Hayvanın menşe ülkesi.",
      "previousOwnerH": "Olgun bir hayvan olması durumunda hayvanın önceki sahibinin adı.",
      "twinH": "Bu alan hayvanın ikizi olup olmadığını belirtir.",
      "regBreedAssoNoH": "Irk Derneklerine/Birliklerine kayıt.",
      "breedAssoNameH": "Hayvanın Kayıtlı Olduğu Dernek/Kuruluşların Adı",
      "breederH": "Bu, hayvanı tedarik eden kuruluşun adıdır.",
      "breeder": "Damızlık",
      "noteH": "Hayvan hakkında önemli not(lar).",
      "accuracyWeight_for_field": "Doğruluk Ağırlık",
      "conception": "gebe kalma",
      "addAnAnimal": "Bir Hayvan Ekle",
      "addAnimal": "Hayvan Ekle",
      "registerAnAnimal": "Bir Hayvanı Kaydet",
      "uploadAnAnimal": "Bir Hayvan Yükle",
      "animalRegistration": "Hayvan Kaydı",
      "animalDetails": "Hayvan Detayları",
      "tag": "Etiket",
      "tagNumber": "Etiket numarası",
      "govtRegNumber": "hükümet ",
      "birthWeight": "Doğum Ağırlığı (lbs)",
      "birthEase": "Doğum Kolaylığı",
      "birthFarm": "doğum çiftliği",
      "surrogateDam": "Taşıyıcı Baraj",
      "owner": "Mal sahibi",
      "ownershipType": "Mülkiyet Türü",
      "animalDiseaseRecord": "HayvanHastalıkKaydı",
      "govtReg": "hükümet ",
      "regDate": "Kayıt Tarihi",
      "dam": "Baraj",
      "sire": "Efendim",
      "heifer": "Düve",
      "steer": "yönlendirmek",
      "calf": "buzağı",
      "farmHerd": "Çiftlik/Sürü",
      "femaleCalf": "dişi buzağı",
      "maleCalf": "erkek buzağı",
      "newCalves": "Yeni Buzağılar",
      "breed": "Yavrulamak",
      "conceptionMethod": "Gebelik Yöntemi",
      "gender": "Cinsiyet",
      "dateOfBirth": "Doğum tarihi",
      "operator": "Şebeke",
      "animalRemovedFarm": "Hayvan Kaldırılan Çiftlik",
      "dateOfAnimalRemoval": "Hayvan Kaldırma Tarihi",
      "destinationOfRemovedAnimal": "Kaldırılan Hayvanın Hedefi",
      "reasonOfRemoval": "Kaldırma Nedeni",
      "optionalAnimalInformation": "Opsiyonel Hayvan Bilgileri",
      "animalPicture": "Hayvan Resmi",
      "trackingNumber": "Takip numarası",
      "brand": "Marka",
      "tatto": "Dövme",
      "hornStatus": "Korna Durumu",
      "animalOrigin": "Hayvan Kökeni",
      "previosOwner": "Önceki Sahibi",
      "twin": "İkiz",
      "InABreedAssociation": "Reg.",
      "nameOfBreedAssociations": "Irk Derneklerinin Adı",
      "breedAssociations": "Irk Dernekleri",
      "breederSupplier": "Yetiştirici (Tedarikçi)",
      "importAnimal": "Hayvan İthalat",
      "loadingAnimals": "Hayvanlar Yükleniyor... Lütfen bekleyin",
      "totalRegAnimals": "Toplam Kayıt ",
      "totalPregnantAnimals": "Toplam Gebe Hayvanlar",
      "pregnantAnimalHistory": "Hamile Hayvan Tarihi",
      "dailyAnimalPregnancyUpdates": "Günlük Hayvan Gebelik Güncellemeleri",
      "animalHistory": "Hayvan Tarihi",
      "dailyAnimalUpdates": "Günlük Hayvan Güncellemeleri",
      "totalPregnant": "Toplam Hamile",
      "totalNewBorn": "Toplam Yeni Doğan",
      "searchByIDGOVRegTag": "Kimliğe, GOV Kaydına ve Etikete Göre Arama",
      "noANIMALAVAILABLE": "MEVCUT HAYVAN YOK",
      "associationNumber": "Dernek Numarası",
      "associationName": "Dernek Adı",
      "destinationName": "Hedef Adı",
      "plastic": "Plastik",
      "metal": "Metal",
      "naturalMating": "Doğal Çiftleşme",
      "artificialInsemination": "Suni dölleme",
      "embryoTransfer": "Embriyo transferi",
      "noAssistance": "Yardım Yok",
      "someAssistance": "Biraz Yardım",
      "mechanicalAssistance": "Mekanik Yardım",
      "aCesareanSection": "sezaryen",
      "abnormalDelivery": "Anormal Teslimat",
      "male": "Erkek",
      "female": "Dişi",
      "castrated": "hadım edilmiş",
      "sale": "Satış",
      "slaughter": "Katliam",
      "death": "Ölüm",
      "theft": "Çalınması",
      "other": "Diğer",
      "horned": "Boynuzlu",
      "polled": "oylandı",
      "dehorned": "boynuzsuz",
      "details": "Detaylar",
      "performance": "Verim",
      "geneticWorth": "Genetik Değer",
      "healthRecord": "Sağlık kaydı",
      "genotypeData": "Genotip Verileri",
      "reminders": "Hatırlatıcılar",
      "activityLog": "Etkinlik Günlüğü",
      "activityLogDetails": "Etkinlik Günlüğü Ayrıntıları",
      "editAnimal": "Hayvanı Düzenle",
      "familyInfo": "Aile Bilgisi",
      "breedInfo": "Irk Bilgisi",
      "identification": "Tanılama",
      "removalInfo": "Kaldırma Bilgisi",
      "iDOfAnimalDam": "Hayvanın barajının kimliği.",
      "iDOfAnimalSire": "Hayvanın babasının kimliği.",
      "iDOfDamEmbryoUsed": "Kimin embriyosunun kullanıldığı barajın kimliği.",
      "animalHasATwinOrNot": "Hayvanın ikizi olup olmadığı.",
      "breedType": "Irk Türü",
      "breedOfTheAnimal": "Bu hayvanın bir cinsidir.",
      "regBreedAssociations": "Irk Dernekleri/Birlikleri ile kayıt.",
      "nameOfAssociationsSocieties": "Hayvanın kayıtlı olduğu Derneklerin/Birliklerin adı.",
      "nameOfTheOrgSuppliedAnimal": "Bu, hayvanı tedarik eden kuruluşun adıdır.",
      "countryOriginAnimal": "Hayvanın menşe ülkesi.",
      "birthFarmID": "Doğum Çiftliği Kimliği",
      "farmIDAnimalBorn": "Hayvanın doğduğu çiftlik kimliği.",
      "currentOwner": "Mevcut Sahibi",
      "nameOfOwnerAnimal": "Bu, hayvanın sahibinin adıdır.",
      "registrationDate": "Kayıt Tarihi",
      "previousOwner": "Önceki sahibi",
      "nameOfOperator": "operatörün adı",
      "dateAnimalRemoved": "Hayvanın çıkarıldığı tarih.",
      "destinationPlaceRemovedAnimal": "Kaldırılan hayvan için varış yeri",
      "namePersonFillAnimalInformation": "Bu hayvanın bilgilerini dolduran kişinin adı.",
      "reasonOfAnimalRemoval": "Hayvanın uzaklaştırılma nedeni",
      "reasonWhyTheAnimalIsRemoved": "Hayvanın uzaklaştırılma nedeni",
      "processingDate": "İşlem tarihi",
      "DateInformationFilledChanged": "Güncel bilgilerin doldurulduğu veya değiştirildiği tarih.",
      "animalID": "Hayvan Kimliği",
      "UniqueIdAnimal": "Bu, hayvanın benzersiz kimliğidir.",
      "plasticTagNumber": "Plastik Etiket Numarası",
      "numberAnimalTag": "Animal etiketinin numarası.",
      "rFTagNumber": "RF Etiket Numarası",
      "numberAnimalRFTag": "Hayvan RF etiketinin numarası.",
      "govtRegNumb": "hükümet ",
      "govtRegistrationNumber": "Kişinin adını ve adresini, kişinin işlem hizmeti temsilcisini, gerçekleştirilecek faaliyetin yerini ve kişinin sağladığı hizmetin açıklamasını içerebilen kimlik bilgileri.",
      "numberAssignedAnimalIsRemoved": "Takip numarası, hayvan aktivitelerini takip etmek için kullanılan hayvan kimliklerinden biridir.",
      "dateOfAnimalRegistration": "Hayvan kayıt tarihi",
      "stockBrandDesignSearedHideAnAnimalCattleColorCodeAnAnimal": "Marka-Sadece ineğin üzerine yakılan kalıcı bir işaret.",
      "tattoOnAnimal": "Hayvan üzerine dövme.",
      "whetherTheAnimalIsDehorned": "Hayvanın boynuzunun kesilip kesilmediği.",
      "milkingAnimals": "Sağılan Hayvanlar",
      "studAnimals": "Damızlık Hayvanlar",
      "animalInseminationRecord": "Hayvan Tohumlama Kaydı",
      "numOfStrawsOrdered": "Sipariş Edilen Pipet Sayısı",
      "totalNumOfStraws": "Toplam Pipet Sayısı",
      "strawId": "Saman Kimliği",
      "addSireAutomation": "Sire Otomasyonu Ekle",
      "addApprovalAutomation": "Onay Otomasyonu Ekle",
      "addCollectionAutomation": "Koleksiyon Otomasyonu Ekle",
      "addStrawsAutomation": "Payet Otomasyonu Ekle",
      "addPackAutomation": "Paket Otomasyonu Ekle",
      "addPostageAutomation": "Posta Otomasyonu Ekle",
      "searchBySire": "aramaBySire",
      "numberOfProgenies": "Döl Sayısı",
      "sireEdit": "Efendim Düzenle",
      "searchByStrawIdtotalNumbersOfStrawsBatchNumberAndLocationId": "Pipet Kimliğine, Toplam Pipet Sayısına, Parti Numarasına ve Konum Kimliğine Göre Arama",
      "searchByPackIdNumberOfStrawsOrderedPackingTechnicia": "Paket Kimliğine göre arama, Sipariş edilen pipet sayısı, Paketleme Tekniği",
      "searchByCollectionAndPreparationTechnicia": "Toplama ve hazırlama tekniğine göre arama",
      "registerSemenAutomation": "Semen Otomasyonuna Kayıt Olun",
      "addSemenAutomation": "Semen Otomasyonu Ekle",
      "strawAutomationRegistered": "Saman Otomasyonu Kayıtlı",
      "strawAutomationRegisteredNotRegistered": "Saman Otomasyonu Kayıtlı Kayıtlı Değil",
      "sireAutomationRegistered": "Sire Otomasyonu Kayıtlı",
      "sireAutomationNotRegistered": "Sire Otomasyonu Kayıtlı Değil",
      "postageAutomationIsRegistered": "Posta Otomasyonu Kayıtlı",
      "postageAutomationNotRegistered": "Posta Otomasyonu Kayıtlı Değil",
      "packAutomationIsRegistered": "Paket Otomasyonu Tescillendi",
      "packAutomationNotRegistered": "Paket Otomasyonu Kayıtlı Değil",
      "postageAutomationIsUpdated": "Posta Otomasyonu Güncellendi",
      "postageAutomationNotUpdated": "Posta Otomasyonu Güncellenmedi",
      "packAutomationIsUpadted": "Paket Otomasyonu Güncellendi",
      "packAutomationNotUpadted": "Paket Otomasyonu Güncellenmedi",
      "collectionAutomationUpdated": "Tahsilat Otomasyonu Güncellendi",
      "collectionAutomationNotUpdated": "Toplama Otomasyonu Güncellenmedi",
      "approvalAutomationIsUpdated": "Onay Otomasyonu Güncellendi",
      "approvalAutomationIsNotUpdated": "Onay Otomasyonu Güncellenmiyor",
      "collectionAutomationRegistered": "Tahsilat Otomasyonu Kayıtlı",
      "collectionAutomationNotRegistered": "Toplama Otomasyonu Kayıtlı Değil",
      "approvalAutomationIsRegistered": "Onay Otomasyonu Kaydedildi",
      "approvalAutomationIsNotRegistered": "Onay Otomasyonu Kayıtlı Değil",
      "strawAutomationUpdated": "Saman Otomasyonu Güncellendi",
      "strawAutomationIsNotUpdated": "Saman Otomasyonu Güncellenmiyor",
      "searchSire": "Arama Efendim",
      "strawsEdit": "Payet Düzenle",
      "nextAnimals": "Sonraki Hayvan",
      "performanceInfo": {
        "milk": "Süt",
        "liveweight": "Canlı ağırlık",
        "score": "Gol",
        "fertility": "Doğurganlık",
        "measurements": "ölçümler",
        "dailyProteinYield": "Günlük Protein Verimi",
        "amountProteinMilkCowDay": "Belirli bir günde bir inekten elde edilen sütteki protein miktarı.",
        "dailyMilkYield": "Günlük süt verimi",
        "volumeMilkCowDay": "Belirli bir günde belirli bir inekten elde edilen süt hacmi.",
        "dailyFatYield": "Günlük Yağ verimi",
        "amountFatMilkCowDay": "Belirli bir günde bir inekten elde edilen sütteki yağ miktarı.",
        "dailyProteinContent": "Günlük protein içeriği",
        "dailyFatContent": "Günlük yağ içeriği",
        "milkLactose": "Süt Laktozu",
        "amountLactoseMilk": "Sütteki laktoz miktarı.",
        "milkUrea": "Süt Üre",
        "indicatorAmountCrudeProtein": "Bir ineğin diyetindeki ham protein miktarının göstergesi",
        "lactationNumber": "emzirme numarası",
        "ordinalNumLactation": "Emzirmenin sıra sayısı.",
        "lengthOfLactation": "Emzirme süresi (örn. 23 gün)",
        "lactationLength": "emzirme süresi",
        "milkingFrequency": "Sağım Sıklığı",
        "frequcnyOfMilking": "Sağım sıklığı (örn. günde 2 kez)",
        "liveWeightInformation": "Canlı Ağırlık Bilgileri",
        "currentWeight": "Mevcut ağırlık",
        "weightAnimal": "Hayvanın ağırlığı.",
        "postWeaningGain": "Sütten kesme sonrası kazanç",
        "dailyGainInAnimalWeightWeaning": "Sütten kesimden sonra hayvanın ağırlığındaki günlük artış.",
        "weaningWeight": "sütten kesme ağırlığı",
        "weightAnimalMeasuredWeaning": "Hayvanın sütten kesim gününde ölçülen ağırlığı.",
        "averageDailyGain": "Ortalama Günlük Kazanç",
        "averageAmountWeightAnimalGainFeedingPeriod": "Bir hayvanın beslenme döneminde her gün alacağı ortalama ağırlık miktarı",
        "carcassWeight": "karkas ağırlığı",
        "weightAnimalsHideInternalOrgansRemoved": "Hayvanların ağırlıkları baş, deri ve iç organları çıkarıldıktan sonra yapılır.",
        "weightAtCalving": "Buzağılamada ağırlık",
        "weightAtTheTimeOfCalving": "Buzağılama sırasındaki ağırlık.",
        "yearlingWeight": "Bir yıllık ağırlık",
        "weightYearOldAnimal": "Bir yaşındaki hayvanın ağırlığı.",
        "somaticCellScore": "Somatik hücre skoru",
        "somaticCellScoreIndicatorMastitis": "Mastit için bir gösterge olarak somatik hücre skoru. ",
        "lastUpdate": "Son Güncelleme",
        "bodyConditionScore": "Vücut kondisyon puanı",
        "scoreAnimalFat": "Sahip olduğu yağ miktarına göre bir hayvan puanı.  ",
        "teatScore": "Meme ucu puanı",
        "scoreMeasureingShapeTeats": "Meme başı boyutu puanları, meme başı uzunluğu ve çevresinin subjektif değerlendirmeleridir ve 9 (çok küçük) ile 1 (çok büyük) arasında değişir. ",
        "udderScore": "Meme Askı Puanı",
        "scoreMeasureingShapeOfUdder": "Memenin şeklini ölçen puan (1-9 puan). ",
        "whetherAnimalEasyBirthDifficult": "Çiftlik hayvanlarında doğum doğal bir süreçtir, ancak bazen barajın çiftçi/çoban yardımına ihtiyaç duyduğu doğum sorunları olabilir.",
        "totalLongevity": "Toplam Ömür",
        "survivalLactationTraitCowCulledBreeding": "1. laktasyondan 5. laktasyona kadar hayatta kalma. ",
        "docility": "Uysallık",
        "circumferenceBullScrotal": "Boğanın skrotal çevresi",
        "intervalSuccessInsemination": "İlk tohumlamadan başarılı tohumlamaya kadar geçen süre.",
        "ageAtFirstCalving": "İlk Buzağılama Yaşı",
        "ageCowCalving": "İlk buzağılamada ineğin yaşı kaçtır?",
        "calvingInterval": "buzağılama aralığı",
        "periodCalving": "Bir buzağılamadan bir sonraki buzağılamaya kadar geçen süre.",
        "scrotalCircumference": "Skrotal Çevre",
        "estrusDetection": "Kızgınlık Tespiti",
        "trackingBehaviorAnimalDetectingEstrus": "Bir ineğin kızgınlığını tespit etmek için hayvanın hareket davranışının izlenmesi.",
        "presenceOfEstrus": "Kızgınlık Varlığı",
        "isCowInEstrusStage": "Bir ineğin östrus aşamasında olduğu veya ne zaman",
        "matureWeight": "Olgun Ağırlık",
        "weightAnimalDefinedAge": "Belirli bir yaştaki bir hayvanın ağırlığı.",
        "matureHeight": "Olgun Boy",
        "heightAnimalDefinedAge": "Belirli bir yaşta bir hayvanın yüksekliği.",
        "footClawSet": "Ayak Pençesi Seti",
        "shapeAnimalClaw": "Hayvan pençesinin şekli.",
        "pulmonaryArterialPressure": "Pulmoner Arter Basıncı",
        "animalBloodPreasure": "Hayvanın kan basıncı.",
        "footAngle": "Ayak Açısı",
        "shapeAnimalFoot": "Hayvanın ayağının şekli.",
        "ribEyeArea": "Kaburga Gözü Alanı",
        "amountRibEyeArea": "Nervürlü alan miktarı.",
        "ultrasoundFat": "Ultrason Yağı",
        "measureFatAmount": "Yağ miktarının ölçüsü.",
        "ultrasoundIntramuscularFat": "Ultrason Kas İçi Yağ",
        "ultrasoundRibEyeArea": "Ultrason Kaburga-Göz Bölgesi",
        "measureRibeyeArea": "Ribeye alanının ölçüsü.",
        "fatThickness": "Yağ Kalınlığı",
        "amountAnimalBackFat": "Hayvanın sırt yağı miktarı.",
        "marbling": "Ebru",
        "marballingMeasurement": "Ebru, kas içinde ve kas lifi demetleri arasında biriken görünür doymamış (sağlıklı) kas içi yağdır.",
        "dryMatterIntake": "Kuru madde alımı",
        "amountFeedAnimalConsumesAMoisture": "Bir hayvanın nemsiz olarak günlük tükettiği yem miktarı."
      },
      "feedsName": "Besleme Adı",
      "feedName": "Besleme Adı",
      "firstFeedQuantity": "İlk Besleme Miktarı",
      "additionalFeed": "Ek Besleme",
      "cloversRyeGrasses": "Yonca, Çavdar otları",
      "greenFodderHayLegumes": "Yeşil Yem, Saman, Bakliyat",
      "feedsRegisteredSuccessfully": "Beslemeler Başarıyla Kaydedildi",
      "feedsNotRegistered": "Beslemeler Kayıtlı Değil",
      "fEEDQUANTITY": "YEM MİKTARI",
      "feedQuantity": "Yem Miktarı",
      "fEEDNAME": "BESLEME ADI",
      "nOFEEDINFOAVAILABLE": "MEVCUT HESAP BİLGİSİ YOK",
      "searchByFeedName": "Besleme adına göre ara",
      "loadingFeedInfo": "Besleme Bilgileri Yükleniyor... Lütfen bekleyin",
      "todayFeedInfo": "Bugün Yayın Bilgisi",
      "feedInfo": "Besleme Bilgisi",
      "loremIpsumDolorSitAmet": "Lorem ipsum dolor sit amet, consectetur adipiscing elit. ",
      "geneticWorthInfo": {
        "breedingValueEconomicIndex": "Bu damızlık değerinin ekonomik indeksin hesaplanmasında kullanılıp kullanılmadığı.",
        "dailyProteinYieldUsed": "Günlük Kullanılan Protein Verimi",
        "weightAssignedBreedingDailyProteinYield": "\"Günlük protein verimine\" karşılık gelen damızlık değerine atanan ağırlık. ",
        "dailyProteinYieldWeight": "Günlük Protein Verim Ağırlığı",
        "rankAnimalInRelationshipEconomicIndex": "Ekonomik endekse göre hayvanın sıralaması.",
        "economicIndexRank": "Ekonomik Endeks Sıralaması",
        "percentileEconomicIndexFall": "Ekonomik endeksin dahil olduğu yüzdelik dilim.",
        "economicIndexPercentile": "Ekonomik Endeks Yüzdelik Dili",
        "accuracyOfEconomicIndex": "Ekonomik endeksin doğruluğu.",
        "economicIndexAccuracy": "Ekonomik Endeks Doğruluğu",
        "weightedAverageOfBreedingValues": "Damızlık değerlerinin ağırlıklı ortalaması.",
        "economicIndex": "Ekonomik Endeks",
        "rankOfAnimalInRelationshipBreeding": "Karşılık gelen damızlık değerine göre hayvanın sıralaması.",
        "dailyProteinYieldBreedingValueRank": "Günlük protein verimi üreme değeri sıralaması ",
        "percentileBreedingFalls": "Damızlık değerinin düştüğü yüzdelik dilim.",
        "dailyProteinYieldBreedingPercentile": "Günlük protein verimi damızlık değeri yüzdelik dilimi ",
        "accuracyEstimatedBreeding": "Tahmini damızlık değerinin doğruluğu.",
        "dailyProteinYieldBreedingAccuracy": "Günlük Protein Verimi Islah Değeri Doğruluğu",
        "estimatedBreedingTraitDailyProteinYield": "Özelliğin tahmini damızlık değeri \"Günlük protein verimi.",
        "dailyProteinYieldBreedingValue": "Günlük Protein Verimi Islah Değeri ",
        "pathToTheDirectoryScriptsBreeding": "Damızlık değerinin hesaplanması için kullanılan betikleri içeren sabit sürücüdeki dizinin yolu.",
        "scriptsPath": "Komut Dosyası Yolu",
        "softwarePackageBreeding": "Damızlık değerini hesaplamak için kullanılan yazılım paketi.",
        "breedingValueSoftware": "Yetiştirme Değeri Yazılımı",
        "methodCalculateBreeding": "Islahı hesaplamak için kullanılan yöntem",
        "breedingValueMethod": "Yetiştirme Değeri Yöntemi",
        "trait": "Karakter",
        "tools": "Aletler",
        "geneticWorth": "Genetik Değer",
        "dailyProteinYield": "Günlük Protein Verimi",
        "breedingValue": "Yetiştirme Değeri",
        "breedingValueBIFAccuracy": "Yetiştirme Değeri BIF Doğruluğu",
        "breedingValuePercentile": "Yetiştirme Değeri Yüzdelik Dilim",
        "breedingValueRank": "Damızlık Değer Sıralaması",
        "checkLTD": "LTD'yi kontrol edin",
        "ultrasoundDiagnostic": "ultrason teşhisi",
        "selectYieldUsed": "Kullanılan verimi seçin",
        "softwareName": "yazılım adı",
        "animalGenWorthUpdatedSuccessfully": "Animal Gen Worth Başarıyla Güncellendi"
      },
      "addNote": "Not ekle",
      "enterNote": "Not Girin",
      "noteIsRequired": "Not gerekli",
      "noteMustBeLessThan50Characters": "Not 50 karakterden az olmalıdır",
      "noteAdded": "Not Eklendi",
      "noteNotAdded": "Not Eklenmedi",
      "noteForAnimal": "Hayvan için not.",
      "noNoteFoundForThisAnimal": "Bu hayvan için not bulunamadı.",
      "inseminationData": "tohumlama verileri",
      "nameOfInseminator": "tohumlama makinesinin adı",
      "activity": "Aktivite",
      "searchByNameActivity": "Ada göre ara, aktivite",
      "searchByTaskNameNumber": "Görev adına, numaraya göre ara",
      "inseminationDate": "Tohumlama Tarihi",
      "genotypeDataInfo": {
        "genotypeAnimalID": "Genotip Hayvan Kimliği",
        "iDTubeBloodSampleAnimalNumberGenotypingService": "Bu, hayvandan veya bir dizi genotipleme hizmetinden alınan kan örneğinin bulunduğu bir tüpün kimliğidir.",
        "geneticTechnicianName": "Genetik Teknisyeni Adı",
        "NameTechnicianBloodSamplesAnimal": "Bu, hayvandan kan örnekleri alan bir teknisyenin adıdır.",
        "sNPData": "SNP verileri",
        "genotypingServiceNote": "Genotipleme Hizmet Notu",
        "InfoGenotypingGenotypingTechnology": "Genotipleme firmasının adı, kullanılan genotipleme teknolojisi, genotipleme tarihi vb. gibi genotipleme ile ilgili tüm bilgiler",
        "numberOfSNPs": "SNP sayısı",
        "numberOfSNPsAnimalGenotyped": "Hayvanın genotiplendiği SNP sayısı",
        "nameOfTheDrug": "İlacın Adı",
        "animalGenoDataUpdatedSuccessfully": "Hayvan Geno Verileri Başarıyla Güncellendi",
        "animalGenoDataNotUpdated": "Hayvan Geno Verileri Güncellenmedi",
        "animalIDIsRequired": "Hayvan kimliği gerekli",
        "techNameIsRequired": "teknoloji ",
        "onlyAlphabetsAreAllowed": "Yalnızca alfabelere izin verilir",
        "genoDataIsRequired": "Geno verileri gerekli",
        "serviceNoteIsRequired": "Servis Notu gerekli",
        "sNPIsRequired": "SNP gerekli"
      },
      "healthRecordInfo": {
        "treatment": "Tedavi",
        "treatmentTakenAnimal": "Hayvana ne muamele yapıldı.",
        "reasonOfTreatment": "Tedavi Nedeni",
        "reasonForTreatment": "Tedavi Nedeni",
        "whatReasonOfTreatment": "Tedavi sebebi nedir?",
        "treatmentDate": "Tedavi Tarihi",
        "dateOfTreatment": "Tedavi tarihi.",
        "diagnosis": "Teşhis",
        "nameDiagnosedDiseaseConditionSymptoms": "Teşhis edilen hastalığın/durumun veya ana semptomların adı",
        "drugID": "İlaç Kimliği",
        "iDOfDrugWhichIsGivenToAnimal": "Hayvana verilen ilacın kimliği.",
        "drugName": "İlaç Adı",
        "nameDrugAnimal": "Hayvanlara verilen ilacın adı.",
        "drugWithdrawalPeriod": "İlaç Bırakma Dönemi",
        "timeAdministrationDrugAnimalMeatMilkHumanConsumption": "İnsan tüketimi için et veya sütün güvenliğini sağlamak için bir hayvana bir ilacın uygulanmasından sonra gereken süre",
        "attendingVeterinarian": "Veteriner",
        "qualifiedPersonCaseAnimal": "Vakayı/hayvanı gören yetkili kişi",
        "packID": "Paket Kimliği",
        "iDPackTreatment": "Tedavi için kullanılan bir paketin kimliği",
        "veterinarianName": "Veteriner Adı",
        "animalNoHealthRecord": "Bu hayvanın herhangi bir Sağlık Kaydı yok. ",
        "addHealthRecord": "Sağlık Kaydı Ekle",
        "healthStatus": "Sağlık durumu",
        "loadingDiseasesPleaseWait": "Hastalıklar Yükleniyor... Lütfen bekleyin",
        "animalDiseaseRecord": "Hayvan Hastalığı Kaydı",
        "animalHealthRecord": "Hayvan Sağlığı Kaydı",
        "animalTreatmentRecord": "Hayvan Tedavi Kaydı",
        "loadingHealthData": "Sağlık Verileri Yükleniyor...",
        "healthRecord": "Sağlık kaydı",
        "nameOfDiagnosis": "Teşhis Adı",
        "treatmentName": "Tedavi Adı",
        "drugGivenBy": "İlaç Veren",
        "recessiveDiseases": "Resesif Hastalıklar",
        "recessiveDiseasesMessage": "Bu boğa hangi resesif hastalık alelinin taşıyıcısıdır?"
      },
      "conceptionInfo": {
        "addNewConception": "Yeni kavram ekle",
        "semenEmbryo": "Semen/Embriyo",
        "pregnancyCheck": "Hamilelik Kontrolü",
        "birthInfo": "Doğum Bilgisi",
        "searchByInseminatorOrganisationBreedingConception": "Dölleyici adı, Kuruluş adı, Yetiştirme hizmet numarası, Gebelik yöntemi ile arama",
        "deliveryDate": "Teslim tarihi",
        "calfId": "buzağı kimliği",
        "birthDayOldWeight": "Doğum (Gün Eski) Ağırlığı",
        "searchByBirthEase": "Doğum kolaylığına göre ara",
        "searchPregnancyCheckOperatorMethod": "Hamilelik kontrolü operatörüne göre arama, Hamilelik kontrolü Yöntemi",
        "pregnancyCheckDate": "Hamilelik Kontrol Tarihi",
        "conceptionSuccess": "Konsept Başarı",
        "pregnancyCheckOperator": "Hamilelik Kontrol Operatörü",
        "pregnancyCheckMethod": "Hamilelik Kontrolü Yöntemi",
        "recentlyPregnant": "Son zamanlarda Hamile",
        "pregnancyConfirmationDate": "Hamilelik Onay Tarihi",
        "pregnancyRate": "Gebelik Oranı",
        "timePeriodOfPregnancy": "Hamilelik Dönemi",
        "semenProduction": "Semen Üretimi",
        "embryoProduction": "Embriyo Üretimi",
        "semen": "meni",
        "embryoTransferDate": "Embriyo Transfer Tarihi",
        "daysOfPregnancy": "Hamilelik Günleri",
        "searchSireEmbryoSurrogate": "Sire kimliği, Embriyo org adı, Vekil baraj ırkına göre arama yapın",
        "selectDate": "Tarih seç",
        "orgnisationNameContainNumber": "Kuruluş Adı sayı içermemelidir",
        "selectBirthEase": "Doğum Kolaylığını Seçin",
        "selectUnit": "Lütfen bir birim seçin",
        "animalConceptionAddedSuccessfully": "Animal Conception Başarıyla Eklendi",
        "postageCustomerName": "Posta Müşteri Adı",
        "searchByPostageCustNameCustAddPostId": "Posta Müşteri Adına, Müşteri Adresine, Posta Kimliğine Göre Ara",
        "dateOfSemenCollection": "Semen Toplama Tarihi",
        "dateOfSemenPreparation": "Semen Hazırlama Tarihi",
        "semenMotility": "Semen Hareketliliği",
        "semenConcentration": "Semen Konsantrasyon",
        "postageEdit": "Posta Düzenle",
        "enterSireId": "Efendi Kimliğini Girin",
        "selectEmbryoOrganisation": "Embriyo Organizasyonunu Seçin",
        "matingDateH": "Gebe kalma tarihi, doğal çiftleşme veya suni tohumlama.",
        "inseminatorNameH": "Tohumlama işlemini yapan kişi (veteriner/teknisyen)",
        "orgNameH": "AI için semen samanı sağlayan kuruluşun veya şirketin adı",
        "brServiceNumH": "Üreme sayısının kaydedilmesi (örn. 1., 2. veya 3.)",
        "conceptionMethodH": "Hayvanın gebe kalma şekli, bir yumurtanın bir sperm tarafından döllenmesiyle belirlenen, gebeliğin başlangıcıdır.",
        "sireIdH": "Hayvanın erkek ebeveyninin/babasının kimliği",
        "damIdH": "Hayvanın dişi ebeveyninin/annesinin kimliği.",
        "sarogatedDamH": "Donör erkek ve donör dişiden alınan döllenmiş yumurtanın daha da geliştirilmesi için implante edildiği dişi ineğin kimliği.",
        "embOrgNameH": "Embriyo için organizasyon adı",
        "sarogateDamBreedH": "Taşıyıcı cinsin tarihi",
        "sireBreedH": "Baba ırkının türü ( brahman, boran)",
        "pregCheckDateH": "Ultrason ve kan testleri kullanılarak ineklerde gebelik 30 günlük gibi erken bir tarihte tespit edilebilmektedir. Palpasyon yöntemi ile ineklerin gebe olduğunun tespit edilebilmesi için genellikle ineklerin en az 35-50 günlük gebe olması gerekmektedir. ",
        "conceptionSuccessH": " Sığırlarda döllenme oranı %90'dır ve ortalama buzağılama oranı yaklaşık %55'tir, bu da yaklaşık %35'lik bir embriyonik-fetal ölüm oranına işaret etmektedir (Diskin ve ark., 2006). ",
        "pregnancyCheckOperatorH": "Veteriner hekimler ve uzman hayvan teknisyenleri bu hizmetleri en yaygın olarak çiftçilere sağlar. ",
        "pregnancyCheckMethodH": "Sığırlarda gebelik teşhisi için en sık kullanılan iki yöntem, üreme yolunun manuel palpasyonu (rektum başına) ve üreme yolunun transrektal ultrasonografisidir.",
        "deliveryDateH": "Doğumun gerçekleştiği tarih",
        "calfIdH": "yeni doğmuş buzağı kimliği",
        "birthEaseH": "Çiftlik hayvanlarında doğum doğal bir süreçtir, ancak bazen barajın çiftçi/çoban yardımına ihtiyaç duyduğu doğum sorunları olabilir.",
        "birthDayOldWeightH": "Bir hayvanın doğum günündeki ağırlığı veya bir günlük yaştaki bir kuşun ağırlığı",
        "customerAddress": "Müşteri adresi"
      },
      "all": "Tüm",
      "ungrouped": "Gruplanmamış Hayvanlar",
      "active": "Gruplanmış Hayvanlar",
      "updateAnimal": "Hayvanı Güncelle"
    },
    "dashboardS": {
      "dailyActivities": "Günlük aktiviteler",
      "pendingTasks": "Bekleyen görevler",
      "performanceOfGeno": "Genotiplerin Performansı",
      "breed": "Yavrulamak",
      "chromosome": "Kromozom",
      "seqChange": "Sıra Değişikliği",
      "inheritance": "Miras",
      "diseaseName": "Hastalık Adı",
      "refSequence": "Referans Sırası",
      "pubmedRef": "Pubmed Referansı",
      "matingDate": "çiftleşme tarihi",
      "inseminatorName": "Dölleyici Adı",
      "orgName": "Kuruluş Adı",
      "brServiceNum": "Yetiştirme Hizmet Numarası",
      "conceptionMethod": "Gebelik Yöntemi",
      "semEmbInfo": "Semen/Embriyo Bilgisi",
      "sireId": "Efendi Kimliği",
      "damID": "Baraj Kimliği",
      "srgDamId": "Vekil Baraj Kimliği",
      "embOrgName": "Embriyo Org. ",
      "srgDamBreed": "Taşıyıcı Baraj Irkı",
      "sireBreed": "Efendi Cinsi",
      "damBreed": "Baraj Cinsi"
    },
    "user": {
      "selectLanguage": "Dil Seçin",
      "unitPreference": "Birim Tercihi",
      "selectUnitOfMeasure": "ölçü birimini seçin",
      "importedUser": "İçe Aktarılan Kullanıcı",
      "impFileStatus": "Dosya Durumunu İçe Aktar",
      "loadingUser": "Kullanıcılar Yükleniyor... Lütfen bekleyin",
      "totalUsers": "Toplam Kullanıcı",
      "pendingUsers": "Bekleyen Kullanıcılar",
      "changePassword": "Şifre değiştir",
      "goodIdeaToUsePassword": "Başka bir yerde kullanmadığınız güçlü bir parola kullanmak iyi bir fikirdir.",
      "enterCurrentPassword": "Güncel şifrenizi giriniz",
      "enterNewPassword": "Yeni Parolayı Girin",
      "reEnterPassword": "Yeni şifreyi tekrar giriniz",
      "enterPassword": "Parolanı Gir",
      "repeatNewPassword": "Yeni şifreyi tekrar girin",
      "emailAddr": "E-posta Adresi",
      "enterYourPhoneNumber": "Telefon numaranızı girin",
      "pleaseTypeOldPassword": "Lütfen eski şifreyi yazınız.",
      "pleaseTypeNewPassword": "Lütfen yeni şifreyi giriniz.",
      "pleaseTypeConfirmPassword": "Lütfen şifreyi onaylayın.",
      "passwordChangedSuccesFully": "parola başarıyla değiştirildi",
      "currentPassword": "Mevcut Şifre",
      "newPassword": "Yeni Şifre",
      "passwordDoesNotMatch": "Parolalar eşleşmiyor.",
      "emailCanNotBeEmpty": "E-posta boş olamaz",
      "profileUpdated": "Profil güncellendi",
      "profileNotUpdated": "Profil Güncellenmedi",
      "unableToVerifyEmail": "E-posta doğrulanamıyor",
      "otpSentOnEmail": "OTP e-postayla gönderildi",
      "otpSentSuccessFully": "OTP başarıyla gönderildi",
      "importUsers": "Kullanıcıları İçe Aktar",
      "imageUpdated": "Resim Güncellendi",
      "departmentName": "Bölüm Adı",
      "departmentNum": "Departman Numarası",
      "departmentAdded": "Departman Eklendi",
      "departmentNotAdded": "Departman Eklenmemiş",
      "searchDepartnment": "Departman Adına veya Numarasına Göre Arama",
      "addDepartMent": "Departman Ekle",
      "addDepartment": "Departman Ekle",
      "roleNameIsRequired": "Rol adı gerekli",
      "roleNameMustBeLessThan15Chars": "Rol adı 15 karakterden az olmalıdır",
      "roleAdded": "Rol Eklendi",
      "editDepartment": "Departmanı Düzenle",
      "departmentUpdated": "Departman Güncellendi",
      "departmentNotUpdated": "Departman Güncellenmedi",
      "deleteDepartment": "Departmanı Sil",
      "deleteDepartmentMessage": "Bu bölümü silmek istediğinizden emin misiniz?",
      "noRoleAvailable": "ROL YOK",
      "roleUpdated": "Rol Güncellendi",
      "roleNotUpdated": "Rol Güncellenmedi",
      "editRole": "Rolü Düzenle",
      "allRole": "Tüm Rol",
      "addNewRole": "Yeni Rol Ekle",
      "allDepartment": "Tüm Departman",
      "permissionsUpdated": "İzinler Güncellendi",
      "permissionsnotUpdated": "İzinler Güncellenmedi",
      "roleNo": "rol numarası",
      "searchByEmailAndName": "E-posta ve ada göre arama yapın",
      "userID": "Kullanıcı kimliği",
      "userUpdated": "Kullanıcı Güncellendi",
      "userNotUpdated": "Kullanıcı Güncellenmedi",
      "userAdded": "Kullanıcı Eklendi",
      "userNotAdded": "Kullanıcı Eklenmedi",
      "activateUser": "Kullanıcıyı Etkinleştir",
      "deactivateUser": "Kullanıcıyı Devre Dışı Bırak",
      "userStatusMsg": "Kullanıcı durumunu değiştirmek istediğinizden emin misiniz?",
      "countryRequired": "Ülke gereklidir",
      "stateRequired": "Devlet gereklidir",
      "cityRequired": "Şehir gerekli",
      "searchByRole": "Rol Numarası, Rol Adı, Departmana Göre Arama",
      "noModuleAvailable": "Kullanılabilir Modül Yok",
      "searchBYModuleName": "Modül Adına Göre Ara"
    },
    "farm": {
      "farmID": "Çiftlik Kimliği",
      "onTheFarm": "Çiftlikte",
      "userRoles": "Kullanıcı rolleri",
      "adduser": "Kullanıcı Ekle",
      "addAuser": "Kullanıcı Ekle",
      "uploadUsers": "Kullanıcıları Yükle",
      "addNewUser": "Yeni Kullanıcı Ekle",
      "selectDept": "Departman Seçin",
      "selectRole": "Rol Seçin",
      "editUser": "kullanıcıyı düzenle",
      "totalFarms": "Toplam Çiftlikler",
      "NoAnimalsRegisteredForthisFarm": "Bu Çiftlik İçin Kayıtlı Hayvan Yok",
      "farmsPerPage": "Sayfa başına çiftlikler",
      "regularFarms": "Düzenli Çiftlikler",
      "farmRegisteredProducts": "Çiftlik Kayıtlı Ürünler",
      "searchByFarmNameAndId": "Çiftlik Adına ve Kimliğine Göre Arama",
      "loadingProductsPleaseWait": "Ürünler Yükleniyor... Lütfen bekleyin",
      "farmName": "Çiftlik Adı",
      "farmLocation": "Çiftlik Yeri",
      "productName": "Ürün adı",
      "stockStatus": "Stok durumu",
      "inStock": "Stokta var",
      "searchByProductName": "Ürün Adına Göre Ara",
      "productCategory": "Ürün Kategorisi",
      "products": "Ürünler",
      "farms": "Çiftlikler",
      "registerAfarm": "Çiftlik Kaydet",
      "govtRegistry": "hükümet ",
      "cooperativeID": "kooperatif kimliği",
      "farmType": "Çiftlik Türü",
      "contractMating": "Sözleşme Seks",
      "customization": "özelleştirme",
      "recordsPerpage": "Sayfa başına kayıt",
      "restoreDefault": "Varsayılana döndür",
      "apply": "Uygula",
      "searchState": "Çiftlik Kimliğine, Devlet Siciline, Kooperatif Kimliğine, Çiftlik Türüne, Sözleşmeli Çiftleşmeye Göre Arama",
      "farmOwner": "Çiftlik Sahibi",
      "govRegistrationNo": "Devlet Sicil Numarası",
      "farmInformation": "Çiftlik Bilgileri",
      "ownershipType": "Mülkiyet Türü",
      "communityName": "Topluluk ismi",
      "farmLicenseInformation": "Çiftlik Lisans Bilgileri",
      "licenseNumber": "Lisans numarası",
      "licenseExpiryDate": "Lisans Bitiş Tarihi",
      "regulatorName": "Regülatör Adı",
      "regulatorRepresentativeName": "Düzenleyici Temsilci Adı",
      "farmLocationSize": "Çiftlik Yeri",
      "productionSystem": "Üretim sistemi",
      "country": "Ülke",
      "state": "Durum",
      "city": "Şehir",
      "street": "Sokak",
      "houseNumber": "Ev numarası",
      "farmRegistration": "Çiftlik Kaydı",
      "cancel": "İptal etmek",
      "register": "Kayıt olmak",
      "ok": "Tamam",
      "totalFarmSize": "Toplam Çiftlik Büyüklüğü",
      "farmGeographicLocation": "Çiftlik Coğrafi Konumu",
      "perimeterPointLongitude": "Çevre Noktası Boylamı",
      "perimeterPointLatitude": "Çevre Noktası Enlemi",
      "perimeterPointLabel": "Çevre Noktası Etiketi",
      "perimeterLength": "Çevre Uzunluğu",
      "farmLatitude": "Çiftlik Enlemi",
      "farmLongitude": "Çiftlik Boylamı",
      "editFarm": "Çiftliği Düzenle",
      "update": "Güncelleme",
      "editAfarm": "Bir çiftliği düzenleyin",
      "nextFarm": "Sonraki Çiftlik",
      "nameoftheFarm": "Çiftliğin Adı",
      "registerAProduct": " Ürün Kaydet",
      "farmProducts": "Çiftlik Ürünleri",
      "calf": "buzağı",
      "steer": "yönlendirmek",
      "heifer": "Düve",
      "sire": "Efendim",
      "dam": "Baraj",
      "registerAnAnimal": "Bir Hayvanı Kaydet",
      "farmAnimals": "Çiftlik hayvanları",
      "farm_type": "Çiftlik tipi",
      "farm_Owner": "Çiftlik Sahibi",
      "dateOfRegistration": "Kayıt Tarihi",
      "dataIsNotAvailableForThisFarm": "Veriler bu Çiftlik için mevcut değil",
      "registerNewProduct": "Yeni Bir Ürün Kaydet",
      "information": "Bilgi",
      "licenseInfo": "Lisans Bilgileri",
      "locationInfo": "Konum Bilgisi",
      "geoLocation": "Coğrafi Konum",
      "perimeterLengthState": "Çiftlik Çevre Uzunluğu (çit uzunluğu)",
      "totalFarmSizeState": "Çiftlik Büyüklüğü",
      "productionSystemState": "Çiftlikte Kullanılan Üretim Sistemi",
      "contractMatingState": "Çiftliğin Katıldığı Sözleşmeli Çiftleştirme Programının Kodu.",
      "ownershipTypeState": "Sahiplik türü",
      "regulatorRepresentativeNameState": "Ruhsatı veren düzenleyiciyi temsil eden kişinin adı",
      "regulatorNameState": "Lisansı veren düzenleyicinin adı",
      "licenseExpiryDateState": "Mevcut Lisansın Süresinin Bittiği Tarih",
      "licenseNumberState": "Düzenleyici tarafından yayınlanan Lisans Numarası",
      "plotNumberState": "Çiftliğin ev numarası.",
      "plotNumber": "Ev/Parsel Numarası",
      "streetStatement": "Çiftliğin sokak adı.",
      "cityStatement": "Çiftliğin bulunduğu şehir.",
      "stateStatement": "Çiftliğin bulunduğu ülkenin bölgesi.",
      "countryState": "Çiftliğin bulunduğu ülke.",
      "perimeterPointLongitudeState": "Çiftlikte bir noktanın boylamı.",
      "perimeterPointLatitudeState": "Çiftlikte bir noktanın enlemi.",
      "perimeterPointLabelState": "Nokta Etiketi.",
      "farmLongitudeState": "Çiftliğin boylamı.",
      "farmLatitudeState": "Çiftliğin enlemi.",
      "farmNameH": "çiftliğin adı",
      "farmTypeH": "Farklı faaliyetlerin yürütüldüğü çiftliğin türü.",
      "farmOwnerH": "Bir çiftliğin sahibinin adı (bilgi girerek Çiftçi adını otomatik oluştur)",
      "ownershipTypeH": "Ektikleri araziye sahip olan/kontrol eden çiftçilerin türü ve olmayanlar.",
      "govtRegNumbH": "Düzenleyici tarafından atanan çiftliğin kayıt numarası",
      "contractMatingH": "Çiftliğin katıldığı sözleşmeli çiftleştirme programının kodu",
      "productionSystemH": "Çiftlikte kullanılan üretim sistemi nedir?",
      "cooperativeIDH": "Çiftliğin üyesi olduğu bir kooperatifin kimliği ",
      "licenseNumberH": "Düzenleyici tarafından yayınlanan bir lisansta, lisansı sahibiyle tanımlayan tanımlayıcı numara.",
      "licenseExpiryDateH": "Mevcut lisansın sona erdiği tarih",
      "regularNameH": "Lisansı veren düzenleyicinin adı",
      "regularRepName": "Ruhsatı veren düzenleyiciyi temsil eden kişinin adı",
      "countryH": "Çiftliğin bulunduğu ülke.",
      "stateH": "Çiftliğin bulunduğu ülkenin bölgesi.",
      "cityH": "Çiftliğin bulunduğu şehir.",
      "streetH": "Çiftliğin sokak adı.",
      "houseNumberH": "Çiftliğin ev numarası.",
      "totalFarmSizeH": "Çiftlik büyüklüğü, nadasa bırakılan arazi dahil, ancak doğal bitki örtüsü, ağaçlar veya mera altındaki arazi hariç olmak üzere, çiftlik tarafından şu anda ekili olan arazinin toplamıdır.",
      "farmLatitudeH": "Ekvatorun kuzeyindeki veya güneyindeki mesafenin ölçüsüdür. ",
      "farmLongitudeH": "Başlangıç ​​meridyeninin doğusundaki veya batısındaki mesafeyi ölçer.",
      "perimeterLengthH": "Çiftlik çevre uzunluğu (çit uzunluğu)",
      "perimeterPointLabelH": "Nokta etiketi. ",
      "perimeterPointLatH": "Çiftlikte bir noktanın enlemi",
      "perimeterPointLongH": "Çiftlikte bir noktanın boylamı",
      "noProductAvailable": "Ürün Bulunamadı",
      "farmUpdated": "Çiftlik Güncellendi",
      "performance": "Verim",
      "milkInformation": "Süt Bilgileri",
      "farmNameRequired": "Çiftlik Adı gerekli"
    },
    "login": {
      "welcome": "Hoş geldin! ",
      "welInfo": "Kimlik bilgilerinizi girin.",
      "login": "Giriş yapmak",
      "forgotPassword": "Parolanızı mı unuttunuz",
      "forgotPasswordDesc": "Lütfen hesabınızla ilişkili e-posta adresini girin. ",
      "backToLogin": "Girişe Geri Dön"
    },
    "actionListmod": {
      "actionList": "Aksiyon listesi",
      "tODAY": "Bugün",
      "createTask": "Görev Oluştur",
      "myActivities": "Benim aktivitelerim",
      "jhonSmith": "Jhon Smith",
      "farmID": "Çiftlik Kimliği",
      "dateOfEvent": "Etkinlik tarihi",
      "actionRequired": "Eylem Gerekli",
      "actionTaken": "Yapılan İşlem",
      "animalEventID": "Hayvan Olay Kimliği",
      "cANCEL": "İptal etmek",
      "cONFIRM": "Onaylamak",
      "sTATEMENT": "Bu kaydı silmek istediğinizden emin misiniz?",
      "dAY": "Gün",
      "wEEK": "Hafta",
      "mONTH": "Ay",
      "sUBMIT": "Göndermek",
      "startDate": "Başlangıç ​​tarihi",
      "endDate": "Bitiş tarihi",
      "rEPEAT": "Tekrarlamak",
      "taskCategory": "Görev Kategorisi",
      "pRIORITY": "Öncelik",
      "aSSIGNEE": "vekil",
      "selectLocation": "konum seçin",
      "selectAnimals": "Bir veya daha fazla hayvan seçin",
      "dESCRIPTION": "Tanım",
      "customRecurrence": "Özel Yineleme",
      "repeatEvery": "Her tekrarla",
      "taskName": "Görev adı",
      "enterDescription": "Açıklama Girin",
      "toDo": "Yapmak",
      "assignTo": "Atamak",
      "status": "Durum",
      "nOTE": "Not",
      "noTaskAvailable": "GÖREV YOK",
      "healthRecord": "Sağlık kaydı",
      "iD": "İD",
      "tAG": "Etiket",
      "dateOfbirth": "Doğum tarihi",
      "taskTakenat": "Alınan Görev",
      "gENDER": "Cinsiyet",
      "bREED": "Yavrulamak",
      "regDate": "Reg. ",
      "updateHealthRecord": "Hayvanlar için Sağlık Kaydını Güncelle",
      "treatment": "Tedavi",
      "reasonOftreatment": "Tedavi Nedeni",
      "treatmentDate": "Tedavi Tarihi",
      "dIAGNOSIS": "Teşhis",
      "drugId": "İlaç Kimliği",
      "drugName": "İlaç Adı",
      "drugWithdrawalperiod": "İlaç Bırakma Dönemi",
      "attendingVeterinarian": "Veteriner",
      "packId": "Paket Kimliği",
      "noItemsselected": "Öğe Seçilmedi",
      "healthRecordsubmission": "Sağlık Kaydı Gönderimi",
      "inseminationRecordsubmission": "Tohumlama-Kayıt Teslimi",
      "inseminatorName": "Dölleyici Adı",
      "inseminatorId": "Tohumlayıcı Kimliği",
      "conceptionRate": "Gebelik Oranı",
      "dateOfmeasurement": "Ölçüm Tarihi",
      "recordSubmission": "Kayıt Gönderimi",
      "uPDATE": "Güncelleme",
      "updateTask": "Görevi Güncelle"
    },
    "inseminatorStatisticsInfo": {
      "addInseminatorInfo": "Tohumlama Bilgisi Ekle",
      "inseminatorNumber": "Tohumlama Numarası",
      "loadingInseminatorPleaseWait": "Tohumlayıcı yükleniyor... Lütfen bekleyin",
      "searchByIDAndName": "Kimliğe ve Ada Göre Ara",
      "inseminatorInfoAdded": "Tohumlayıcı Bilgisi Eklendi",
      "inseminatorInfoNotAdded": "Tohumlayıcı Bilgisi Eklenmedi",
      "inseminatorInfoUpdated": "Tohumlayıcı Bilgileri Güncellendi",
      "inseminatorInfoNotUpdated": "Tohumlayıcı Bilgisi Güncellenmedi",
      "editAInseminatorInfo": "Tohumlama Bilgisini Düzenle",
      "inseminatorList": "Tohumlayıcı Listesi",
      "inseminatorInfoDetails": "Tohumlayıcı Bilgi Ayrıntıları",
      "updateInseminatorInfo": "Tohumlama Bilgisini Güncelle"
    },
    "organizationNtrInfo": {
      "loadingOrdersPleaseWait": "Siparişler Yükleniyor... Lütfen bekleyin",
      "addStocks": "Stok Ekle",
      "addStock": "Stok Ekle",
      "quantity": "Miktar",
      "selectUnit": "Birim Seç",
      "farmProducts": "Çiftlik Ürünleri",
      "cost": "Maliyet",
      "transactionID": "İşlem Kimliği",
      "recipientID": "alıcı kimliği",
      "orderID": "Sipariş Kimliği",
      "recepientName": "Alıcı Adı",
      "createAOrder": "sipariş oluştur",
      "totalStocks": "Toplam Stoklar",
      "orders": "Emirler",
      "totalPending": "Toplam Bekleyen",
      "totalDelivered": "Toplam Teslim",
      "searchByRecepientNameOrderIdRecepientId": "Alıcı Adı, Sipariş Kimliği, Alıcı Kimliğine Göre Arama",
      "chooseTheDate": "tarihi seçin",
      "transactionDate": "İşlem Tarihi",
      "selectCategory": "Kategori seç",
      "volumeOfProduct": "Ürün Hacmi",
      "productQuantity": "Ürün miktarı",
      "productRecipientId": "Ürün Alıcı Kimliği",
      "productRecipientName": "Ürün Alıcı Adı",
      "productRecipientType": "Ürün Alıcı Türü",
      "singleProduct": "Tek Ürün",
      "orderPlaced": "sipariş verildi",
      "orderNotPlaced": "Sipariş Verilmedi",
      "totalPrice": "Toplam fiyat",
      "currency": "Para birimi",
      "selectCurrency": "Para birimini seçin",
      "address": "Adres",
      "enterAddress": "Adresi girin",
      "attachments": "Ekler",
      "chooseFile": "Dosya seçin",
      "nameOfTheFarm": "çiftliğin adı",
      "loremIpsumHasBeenTheIndustrySStandardDummyText": "Lorem Ipsum, 1500'lü yıllardan beri endüstrinin standart sahte metni olmuştur.",
      "billedTo": "Fatura",
      "orderStatus": "Sipariş durumu",
      "selectStatus": "Durum Seç",
      "cadbury": "Cadbury",
      "totalAmount": "Toplam tutar",
      "deliveryCharges": "Teslimat ücretleri",
      "orderDetails": "sipariş detayları",
      "deliveryOnTime": "Zamanında teslimat",
      "productID": "ürün kimliği",
      "productRegistration": "Ürün kaydı",
      "enterTheNameOfTheProduct": "Ürünün adını girin",
      "nameOfTheProduct": "Ürünün Adı",
      "productAdded": "Ürün Eklendi",
      "productNotAdded": "Ürün Eklenmedi"
    },
    "drug": {
      "dRUGS": "İlaçlar",
      "registerAdrug": "İlaç Kaydı",
      "sEARCH": "Aramak",
      "genericName": "Genel isim",
      "manufacturer": "Üretici firma",
      "distributor": "Distribütör",
      "registrationDate": "Kayıt Tarihi",
      "drugRegistration": "İlaç Kaydı",
      "drugInformation": "İlaç Bilgileri",
      "packExpiration": "Paket Son Kullanma Tarihi",
      "drugId": "İlaç Kimliği",
      "drugName": "İlaç Adı",
      "drugGenericname": "İlaç Jenerik Adı",
      "drugManufacturer": "İlaç Üreticisi",
      "distributorName": "Distribütör Adı",
      "drugRegistrationdate": "İlaç Kayıt Tarihi",
      "nextDrug": "Sonraki İlaç",
      "editDrug": "İlacı Düzenle",
      "updateDrug": "İlacı Güncelle",
      "deleteDrug": "İlacı Sil",
      "noRecordfound": "Kayıt Bulunamadı",
      "addDrug": "İlaç Ekle",
      "statementDrug": "İlaç silindi.  ",
      "cANCEL": "İptal etmek",
      "cONFIRM": "Onaylamak",
      "sTATEMENT": "Bu kaydı silmek istediğinizden emin misiniz?",
      "ok": " Tamam",
      "information": "Bilgi",
      "packOrder": "Paket Sırası",
      "packPrescription": "Paket Reçetesi",
      "packReservation": "Paket Rezervasyonu",
      "packLocation": "Paket Konumu",
      "drugDozedam": "Baraj İçin Bir Günde İlaç Dozu",
      "drugDozecalf": "Buzağı İçin Bir Günde İlaç Dozu",
      "drugFormate": "İlaç Formatı",
      "drugDistributor": "İlaç Dağıtıcısı",
      "drugActiveingridents": "İlaç Aktif Maddeleri",
      "drugSubstitutionId": "İlaç İkame Kimliği",
      "packId": "Paket Kimliği",
      "packBatchNumber": "Paket Parti Numarası",
      "drugIdStatement": "İlacın parti numarası.",
      "drugNameSatement": "İlacın altında satıldığı reklamı yapılan marka adı.",
      "drugGenericnameStatement": "İlacın altında satıldığı reklamı yapılan marka adı yerine ilacın kimyasal yapısı.",
      "drugFormateSatement": "İlacın parti numarası.",
      "drugDozecalfSatement": "Buzağıya verilecek ilaç dozu miktarını bilmek.",
      "drugDozedamStatement": "Anneye verilecek ilaç doz miktarını bilmek.",
      "drugManufacturerStatement": "İlaç üreticisinin ayrıntıları.",
      "drugDistributorStatement": "İlaç dağıtıcısının ayrıntıları.",
      "drugRegistrationdateStatement": "Belirli bir ülkede ilaç tescil tarihi.",
      "drugActiveingridentsStatement": "Aktif bileşenlerin listesi.",
      "drugSubstitutionIdStatement": "Ana ilacın şu anda mevcut olmaması durumunda, ilaç için olası ikamelerin kimlikleri.",
      "packIdStatement": "Paketin barkodu veya RF kimliği.",
      "packBatchNumberStatement": "Üretici tarafından pakete atanan parti numarası.",
      "locationWarehouseID": "Konum Depo Kimliği",
      "locationWarehouseIDState": "Paketin saklandığı ambarın kimliği.",
      "locationRackID": "Konum Raf Kimliği",
      "locationRackIDStatement": "Paketin saklandığı rafın kimliği.",
      "locationTierID": "Konum Katman Kimliği",
      "locationTierIDStatement": "Paketin depolandığı raftaki katmanın kimliği.",
      "locationPositionID": "Konum Pozisyon Kimliği",
      "locationPositionIDStatement": "Paketin depolandığı bir katmandaki konumun kimliği.",
      "storageTemperatureCondition": "Saklama Sıcaklığı Durumu",
      "storageTemperatureConditionStats": "Paket saklama durumu.",
      "containerForm": "Konteyner Formu",
      "containerFormStatement": "İlacın paketlendiği kap şekli.",
      "consistQuantity": "Oluşan Miktar",
      "consistQuantityStatement": "Paketteki hap, şişe vb. miktarı.",
      "releaseId": "Yayın Kimliği",
      "releaseIdStatement": "Paketin çiftçi tarafından alınmasından sonra atanan kimlik.",
      "releaseDate": "Yayın tarihi",
      "releaseDateStatement": "Paketin çiftçi tarafından stoktan alındığı tarih.",
      "packManufacturedDate": "Paket üretim tarihi",
      "packManufacturedDateStatement": "Paketin üretildiği tarih.",
      "packImportedDate": "Paket İçe Aktarma Tarihi",
      "packImportedDateStatement": "Paketin içe aktarıldığı tarih.",
      "packExpirationDate": "Paket Son Kullanma Tarihi",
      "packExpirationDateStatement": "Paketin son kullanma tarihi.",
      "expiredSoonFlag": "Süresi Dolan Yakında Bayrağı",
      "expiredSoonFlagState": "Yakında sona erecek paket hakkında uyarı.",
      "packTotalVolumeLeft": "Kalan Paket Toplam Hacmi",
      "packTotalVolumeLeftState": "Stokta kalan aynı malzemeleri içeren paketlerin toplam sayısı.",
      "packOrderID": "Paket Sipariş Kimliği",
      "packOrderIDState": "Distribütörden paketi sipariş ettikten sonra atanan kimlik.",
      "packQuantityOrdered": "Sipariş Edilen Paket Miktarı",
      "packQuantityOrderedState": "Distribütörden sipariş edilen paket sayısı.",
      "packPrice": "Paket Fiyatı",
      "packPriceStatement": "Paket fiyatı.",
      "priceCurrency": "Fiyat Para Birimi",
      "packPricecurrency": "Paket Fiyatı Para Birimi",
      "packPricecurrencyState": "Fiyatın aday gösterildiği para birimi adı.",
      "packPaydate": "Paket Ödeme Tarihi",
      "payDate": "ödeme tarihi",
      "packPaydateState": "Ödemenin distribütöre gönderildiği tarih.",
      "packShippingID": "Paket Gönderi Kimliği",
      "shippingID": "Gönderim Kimliği",
      "packShippingIdState": "Distribütörden geldiğinde paketin nakliye kimliği.",
      "packShippingDate": "Paket Gönderim Tarihi",
      "shippingDate": "Sevkiyat Tarihi",
      "packShippingDateState": "Paketin stoka varış tarihi.",
      "packOrderStatus": "Paket Sipariş Durumu",
      "packOrderStatusState": "Geçerli siparişin durumu.",
      "recepientKeeperId": "Alıcı Koruyucu Kimliği",
      "recepientKeeperIdStatement": "Paketi alan kişinin/kuruluşun adı.",
      "recepientFarmId": "Alıcı Çiftlik Kimliği",
      "recepientFarmIdStatement": "Hayvansal ilaç deposunun ait olduğu çiftliğin kimliği.",
      "recepientAnimalId": "Alıcı Hayvan Kimliği",
      "recepientAnimalIdState": "İlacın (paket) reçete edildiği hayvanın kimliği.",
      "specialistComments": "Uzman Yorumları",
      "specialistCommentsState": "Reçete ile ilgili uzman/veteriner hekim yorumları.",
      "specialistName": "Uzman Adı",
      "specialistNameState": "İlacı reçete eden uzmanın/veterinerin adı.",
      "specialistID": "Uzman Kimliği",
      "specialistIDState": "İlacı reçete eden uzmanın/veterinerin kimliği.",
      "reservedByKeeperId": "Bekçi Kimliğine Göre Ayrıldı",
      "reservedByKeeperIdState": "Paketi kimin ayırdığının bekçi kimliği.",
      "reservedByFarmId": "Çiftlik Kimliğine Göre Ayrılmış",
      "reservedByFarmIdState": "Paketin rezerve edildiği çiftlik kimliği.",
      "reservationTimeoutDate": "Rezervasyon Zaman Aşımı Tarihi",
      "reservationTimeoutDateState": "Paketin satın alınmaması durumunda rezervasyonun otomatik olarak iptal edileceği tarih.",
      "reservationTimeout": "Rezervasyon Zaman Aşımı",
      "reservationTimeoutState": "Paketin satın alınmaması veya alınmaması durumunda rezervasyonun otomatik olarak iptal edileceği saat sayısı",
      "reservationDate": "Rezervasyon Tarihi",
      "reservationDateState": "Paketin rezervasyon tarihi.",
      "reservationStatus": "Rezervasyon Durumu",
      "reservationStatusState": "Paket rezervasyonunun durumu. ",
      "loadingDrugsPleaseWait": "İlaçlar Yükleniyor... Lütfen bekleyin",
      "quantityOrder": "Miktar Siparişi",
      "keeperID": "Kaleci kimliği",
      "timeoutDate": "Zaman Aşımı Tarihi",
      "warehouseID": "Depo Kimliği",
      "rackID": "Raf Kimliği",
      "tierID": "Katman Kimliği",
      "positionID": "Pozisyon Kimliği",
      "temperatureCondition": "Sıcaklık Durumu",
      "manufactureDate": "Üretim tarihi",
      "importedDate": "İçe Aktarma Tarihi",
      "totalVolumeLeft": "Kalan Toplam Hacim"
    },
    "reports": {
      "myReports": "Raporlarım",
      "satelliteReports": "Uydu Raporları",
      "weatherReports": "Hava raporu",
      "pregnancyAnalytics": "Hamilelik Analitiği",
      "semenEmbroyAnalytics": "Semen/Embriyo Analizi",
      "semenAnalytics": "Semen Analitiği",
      "embryoAnalytics": "Embriyo Analitiği",
      "calfAnalytics": "Buzağı Analitiği",
      "milkProduction": "Süt Üretimi",
      "totalMilkType": "Toplam Süt Türü",
      "totalAnimalAnalytics": "Toplam Hayvan Analitiği",
      "animalAnalytics": "Hayvan Analitiği",
      "analyticsAndReporting": "Analitik ve Raporlama",
      "filterByCountry": "Ülkeye Göre Filtrele",
      "filterByFarm": "Çiftliğe Göre Filtrele",
      "filterByRegion": "Bölgeye Göre Filtrele",
      "filterByMonth": "Aya Göre Filtrele",
      "filterByDate": "Tarihe Göre Filtrele",
      "filterByRole": "Role Göre Filtrele",
      "filterByYear": "Yıla Göre Filtrele",
      "filterByTrait": "Özelliğe Göre Filtrele",
      "avgBreedingValue": "Ortalama Yetiştirme Değeri",
      "avgEconomicIndex": "Ortalama Ekonomik Endeks",
      "breederReport": "Damızlık Raporu",
      "semenTransferDate": "Meni Transfer Tarihi",
      "semenEmbryoProductionReport": "Semen/Embriyo Üretim Raporu",
      "semenProducts": "Semen Ürünleri",
      "meatProducts": "Et Ürünleri",
      "totalProducts": "Toplam Ürün",
      "semenEmbryoReport": "Semen/Embriyo Raporu",
      "numOfStraws": "Pipet Sayısı",
      "collectionDate": "Toplama Tarihi",
      "productionReport": "Üretim Raporu",
      "receipientId": "alıcı kimliği",
      "embryoId": "embriyo kimliği",
      "semenStrawId": "Semen Samanı Kimliği",
      "dataScientist": "Veri Bilimcisi",
      "dataScientistReport": "Veri Bilimcisi Raporu",
      "productReport": "Ürün Raporu",
      "dairyProducts": "Süt Ürünleri"
    },
    "genoPerformance": {
      "performanceOfGenoType": "GenoType Performansı",
      "addAGenoType": "Bir GenoType ekleyin",
      "breedName": "Irk Adı",
      "chromosome": "Kromozom",
      "sequenceChange": "Sıra Değişikliği",
      "inheritance": "Miras",
      "diseaseName": "Hastalık Adı",
      "referenceSequence": "Referans Sırası",
      "pubmedReference": "Pubmed Referansı",
      "genoTypeRegistration": "GenoType Kaydı",
      "breed": "Yavrulamak",
      "editAGenoType": "Bir GenoType'ı düzenleyin",
      "editGenoType": "GenoType'ı Düzenle",
      "loadingGene": "Geno yükleniyor... Lütfen bekleyin",
      "geneTypeList": "GenoType Listesi"
    },
    "reportings": {
      "conception": "Konsept(Veri Bilimcisi)",
      "performanceOfGenoData": "Genotip Performansı(Veri Bilimcisi)",
      "totalInsemination": "Toplam Tohumlama",
      "embryo": "Embriyo",
      "animalVaccinationRecord": "Hayvan Aşılama Kaydı",
      "dataNotAvailable": "Bu Çiftlik için Veri Yok.",
      "pregnancyStatus": "Hamilelik Durumu",
      "healthReport": "Sağlık raporu",
      "heavyMilk": "Ağır Süt",
      "standardMilk": "Standart Süt"
    },
    "sidebar": {
      "healthAnalytics": "Sağlık Analitiği",
      "productionAnalytics": "Üretim Analitiği"
    },
    "epd": {
      "regNo": "Hayvan Kayıt No, bir işaretleme aracı kullanılarak hayvana verilen benzersiz koddur ve belirli hayvanları tanımlamak ve takip etmek için bir işlem yapılmasını sağlar.",
      "internationalID": "Uluslararası Hayvan Kimliği",
      "location": "Hayvanın Doğurduğu Ülke/Bölge ",
      "animalName": "Hayvanın Standart Adı / Terminolojisi",
      "gender": "Hayvanın cinsiyeti (erkek/dişi)",
      "additionalIDMethod": "Hayvanı tanımlamak için hangi yöntem kullanıldı (ör. küpe, dövme)",
      "damID": "Hayvanın anasının kimliği veya Kayıt numarası-bir hayvanın dişi ebeveyni/Biyolojik annenin kimlik numarası",
      "sireId": "Bir hayvanın erkek ebeveyninin kimliği veya Kayıt numarası, özellikle üreme için tutulan bir boğa veya Suni Tohumlama için kullanılan boğa sperması.",
      "dateOfBirth": "Hayvanın doğum tarihi.",
      "breederHerdCode": "Damızlık Sürü Kodu çoğunlukla Damızlık Dernekleri tarafından verilir",
      "seasonofBirth": "Ay bazında belirtilen Hayvanın Doğum Mevsimi",
      "birthYear": "Hayvanın doğduğu yıl",
      "birthManagementCode": "Çoğunlukla kullanıcı/çiftçi tarafından sağlanan Doğum Yönetim Kodu",
      "birthSex": "Hayvanın cinsiyeti (erkek/dişi)",
      "birthWeight": "Buzağının Doğum Ağırlığı ",
      "primaryBreed": "Hayvanın önemli % Genetik katkısı ",
      "secondaryBreed": "Küçük % Hayvanın genetik katkısı ",
      "breedComposition": "Irk bileşimi yüzdesi, tek bir hayvanın veya bir hayvan grubunun genetik yapısında farklı ırkların orantılı temsilini ifade eder. ",
      "conceptionMethod": "Hayvanın gebe kalma şekli (doğal çiftleşme/dölleme/embriyo transferi).",
      "accuracyWeight": "Doğruluk Ağırlık",
      "damAge": "Barajın ay/yıl cinsinden yaşı, örn. ",
      "weaningWeight": "Sütten kesim sırasında bir hayvanın ağırlığı.",
      "weaningDate": "Hangi hayvanın sütten kesildiği tarih",
      "weaningSex": "Sütten kesilen hayvanın cinsiyeti. ",
      "managementPastureCode": "Kullanıcı/çiftçi tarafından yönetime/meraya verilen kod ",
      "creep": "Sürünerek besleme, emziren buzağılara ek yem (tahıl veya yem) sağlama uygulamasıdır.",
      "weaningContemporaryGroupCode": "Sütten Kesme Ağırlığı Çağdaş Grup Kodu",
      "birthContemporaryCode": "Doğum Çağdaş Kodu",
      "yearlingDate": "Bir yaşındaki veya yaşının ikinci yılındaki hayvanın tarihi",
      "managementFeedUnitCode": "Kullanıcı tarafından yönetim/besleme birimine verilen kod",
      "yearlingSex": "Bir yaşındaki hayvanın cinsiyeti ",
      "yearlingWeight": "Toklu Yavru Ağırlığı, sütten kesim sonrası doğrudan büyümenin bir ölçüsüdür ve genellikle besi yerindeki pazara bağlı yavruların potansiyel performansını yansıtmak için kullanılır ve buzağı pounduyla ölçülür.",
      "yearlingHeight": "Hayvanın toklu zamanındaki yüksekliği ",
      "yearlingWeightContemporaryGroupCode": "Toklu Ağırlık Kodu Çağdaş Grup",
      "weaningYearlingWeightContemporaryGroupCode": "Sütten Kesme veya Bir Yaşındaki Ağırlık Contemporary Group'un kodu",
      "daysOnFeed": "Belirli bir yemle beslenen gün sayısı Örn: genç büyüyen sığırlar, düşük bir kazanç maliyetiyle pazarlanabilir sığır eti üretmek için yüksek enerjili bir diyetle beslenir. ",
      "managementFeedUnitPenCode": "Kullanıcı tarafından yönetime/besleme birimine/kaleme verilen kod",
      "harvestDate": "Eti için kesilen (öldürülen) hayvanın tarihi",
      "gradingDate": "Karkasların tarihi belirli bir kritere göre derecelendirildi",
      "carcassSex": "Karkasın cinsiyeti",
      "dateonFeed": "Hayvanın yeni yeme geçtiği tarih Örn: genç büyüyen sığırlar, düşük bir kazanç maliyetiyle pazarlanabilir sığır eti üretmek için yüksek enerjili bir diyetle beslenir. ",
      "KPH": "% KPH, bir karkasın vücut boşluğunda özellikle böbrekler, pelvis ve kalp bölgelerinde bulunan toplam yağın yüzdesidir. ",
      "carcassWeight": "Karkas ağırlığı, deri, baş, mide-bağırsak sistemi ve iç organların hasat edilmesinden ve çıkarılmasından sonraki sıcak veya soğutulmamış ağırlıktır. ",
      "fatThickness": "Yağ kalınlığı, küçük bir cetvel kullanılarak inç cinsinden ölçülür. ",
      "marbling": "Ebru, kas içinde ve kas lifi demetleri arasında biriken görünür doymamış (sağlıklı) kas içi yağdır.",
      "ribeyeArea": "Bir ızgara kullanılarak (örn. 8, 9 veya 10 inç) inç kare cinsinden 12. ve 13. kaburgalar arasında ölçülen nervür gözü (bel veya ribeye kası longissimus dorsi) alanı miktarı. ",
      "animalStatus": "Çiftlikteki hayvanın durumu örneğin: sağlıklı, hasta vb."
    },
    "manageAnimalGroupings": {
      "resetModeTooltip": "\n        SIFIRLAMA MODU <br>\n            bu modda <br>\n            1) İlgili tüm özellikler için tüm çağdaş grupların (CG'ler) özelliklerini belirleyin/tanımlayın. <br>\n            2) Tüm hayvanları karşılık gelen bir CG'ye atayın. <br>\n            3) Hayvanların atanması tatmin edici değilse, CG'leri ayarlayın/değiştirin ve ardından hayvanları ilgili yeni CG'lere yeniden atayın. <br>\n            4) Gerekirse, CG'lerden ve karşılık gelen hayvan gruplandırmasından/atamasından memnun kalana kadar yukarıdaki adımları tekrarlayın.<br>\n        ",
      "maintainanceModeHeadingTooltip": "RESET (mod) sonlandırıldığında, RESET'te hesaplanan EDP'lerin bir sonraki RESET'e kadar (2-6 ay sonra olabilir) her hayvan için sabit tutulacağı BAKIM MODUNA gireceksiniz. ",
      "maintainanceModeTooltip": "RESET MODU'nu tamamladıktan sonra, sistemin tüm hayvanların EPD'lerini hesaplamasını sağlamak için RESET FINALIZED düğmesine basın, RESET MODU'nu sonlandırın ve BAKIM MODU'nu başlatın.",
      "resetToggleTooltip": "Hayvanları CG'lere atamak için EPD model ayarında Reset Toggle'ı etkinleştirin."
    },
    "geneticsAndBreeding": {
      "geneticsAndBreeding": "Genetik",
      "geneticSearchTool": "Genetik Arama Aracı",
      "dataSubmission": "Veri Gönderme / Hayvan Seçimi",
      "animalsWithExpectedProgenyDifferences": "Beklenen Döl Farklılıkları (EPD'ler) hesaplaması için Hayvan Seçimi",
      "searchByAnimalIdName": "Hayvan Kimliğine, Adına Göre Arama",
      "rowsPerPage": "Sayfa başına satır",
      "individualEntry": "Bireysel Giriş",
      "bulkEntry": "Toplu Giriş",
      "registerANewAnimalOrSelectAnExistingAnimal": "Yeni bir hayvan kaydedin veya mevcut bir hayvanı seçin.",
      "registerNewAnimal": "Yeni Hayvan Kaydet",
      "selectExistingAnimal": "Mevcut Hayvanı Seçin",
      "animalID": "Hayvan Kimliği",
      "animalName": "Hayvan Adı",
      "tag": "Etiket",
      "dateOfBirth": "Doğum tarihi",
      "gender": "Cinsiyet",
      "birthDate": "Doğum günü",
      "birthWeightLb": "Doğum Ağırlığı (lb)",
      "birthWeightKg": "Doğum Ağırlığı(kg)",
      "weaningWeightLb": "Sütten Kesme Ağırlığı (lb)",
      "weaningWeightKg": "Sütten Kesme Ağırlığı(kg)",
      "yearlingWeightLb": "Bir Yıllık Ağırlık (lb)",
      "yearlingWeightKg": "Toklu Ağırlık(kg)",
      "carcassWeightLb": "Karkas Ağırlığı (lb)",
      "carcassWeightKg": "Karkas Ağırlığı(kg)",
      "animalSelection": "Hayvan Seçimi",
      "animalSearchTool": "Hayvan Arama Aracı",
      "back": "Geri",
      "searchByEPDs": "EPD'lere göre ara",
      "searchByIds": "Kimliklere Göre Ara",
      "selectBreed": "Irk Seçin",
      "selectGender": "Cinsiyet seç",
      "selectRequiredBreedForCattle": "Sığır İçin Gerekli Cinsi Seçin",
      "resetFilter": "FİLTRE SIFIRLA",
      "birthWeightHeader": "Doğum Ağırlığı (BW): ",
      "birthWeightDef": "Buzağıların doğumdaki ağırlıklarındaki farklılıkları karşılaştırır ve pound veya kg olarak ölçülür.",
      "weaningWeightHeader": "Sütten Kesme Ağırlığı (WW): ",
      "weaningWeightDef": "WW EPD, pound veya kg olarak ölçülen sütten kesme öncesi büyüme tahminidir.",
      "yearlingWeightHeader": "Toklu Ağırlık(YW): ",
      "yearlingWeightDef": "YW EPD, sütten kesme sonrası kilo veya kg cinsinden ölçülen bir büyüme tahminidir.",
      "ribEyeAreaHeader": "Ribeye Bölgesi(REA): ",
      "ribEyeAreaDef": "REA, ribeye'ı bize inç kare cinsinden veren kasın büyüklüğünü ölçer. REA EPD'leri, hasat edilmiş sığırların karkas ölçümlerine dayalı olarak düzeltilmiş 365 günlük ribeye alanı ölçümündeki farklılıkları yansıtır.",
      "marblingHeader": "Ebru(MARB): ",
      "marblingDef": "MARB EPD, antrikot içindeki kas içi yağ yüzdesi birimi cinsindendir. MARB EPD'leri, hasat edilmiş sığırların karkas ölçümlerine dayalı olarak düzeltilmiş 365 günlük ebru skorundaki (kas içi yağ, [IMF]) farklılıkları yansıtır.",
      "fatThicknessHeader": "Yağ Kalınlığı (FAT): ",
      "fatThicknessDef": "İnç sırt yağı (bir inçin yüzde biri cinsinden) FT için ölçü birimidir.",
      "carcassWeightHeader": "Karkas Ağırlığı(CW): ",
      "carcassWeightDef": "Karkas ağırlığı, poundun nihai ürün değerine göre sahip olduğu etki düşünüldüğünde faydalı bir özelliktir. ",
      "yieldGradeHeader": "Verim Derecesi (YG): ",
      "yieldGradeDef": "USDA Verim Notu puanlama sistemi, YG EPD için ölçü birimidir. ",
      "milkHeader": "Süt(MK): ",
      "milkDef": "MK EPD, annesinin süt sağma kabiliyeti nedeniyle buzağının sütten kesim ağırlığı olarak ölçülür.",
      "totalMaternalHeader": "Toplam Anne(TM): ",
      "totalMaternalDef": "TM, hem süt üretimi hem de ineğin büyüme genetiği nedeniyle buzağının sütten kesim ağırlığı üzerindeki etkisini ölçer.",
      "calvingEaseDirectHeader": "Doğrudan Buzağılama Kolaylığı(CED): ",
      "calvingEaseDirectDef": "CED EPD, yardımsız buzağılamaların yüzdesi olarak listelenmiştir.",
      "calvingEaseMaternalHeader": "Buzağılama Kolaylığı Maternal(CEM): ",
      "calvingEaseMaternalDef": "Bir boğanın kızlarının iki yaşında yardımsız buzağılama yeteneğini ölçer.",
      "stayabilityHeader": "Kalıcılık (STAY): ",
      "stayabilityDef": "ST EPD, bir boğanın \"etrafta kalan\" inekleri doğurma yeteneğini tahmin eder. ",
      "docilityHeader": "Uysallık(DOC): ",
      "docilityDef": "DOC, sığırların mizacını ölçer.",
      "max": "MAKS.",
      "min": "DAK",
      "accuracy": "KESİNLİK",
      "sortBy": "Göre sırala",
      "traits": "Gri renkle gösterilen özellikler geliştirme aşamasındadır ve 2023'ün 2. çeyreğinde kullanıma sunulacaktır.",
      "searchResults": "Arama Sonuçları",
      "recordsFound": "bulunan kayıtlar",
      "compareSelected": "SEÇİLENLERİ KARŞILAŞTIR",
      "animalIdentification": "Hayvan Kimlik",
      "errorMessage": {
        "birthWeight": "Doğum ağırlığı maksimum değeri, Doğum ağırlığı minimum değerinden az olamaz",
        "weaningWeight": "Sütten kesme ağırlığı maksimum değeri Sütten kesme ağırlığından daha az olamaz",
        "yearlingWeight": "Toklu ağırlık maksimum değeri, Toklu ağırlık minimum değerinden az olamaz",
        "carcassWeight": "Karkas ağırlığı maksimum değeri, Doğum ağırlığı minimum değerinden az olamaz",
        "fatThickness": "Yağ Kalınlığı maksimum değeri Sütten kesme ağırlığından daha az olamaz",
        "marbling": "Ebru maksimum değeri, toklu ağırlığının minimum değerinden az olamaz.",
        "ribeyeArea": "Ribeye Alanı maksimum değeri, Minimum Doğum ağırlığı değerinden az olamaz",
        "yieldGrade": "Verim Derecesi maksimum değeri Sütten kesme ağırlığı minimum değerinden az olamaz",
        "milk": "Süt maksimum değeri Sütten kesme ağırlığı minimum değerinden az olamaz"
      },
      "reg": "kayıt",
      "name": "İsim",
      "sex": "Seks",
      "tattoo": "Dövme",
      "dob": "DOB",
      "EPD": "EPD",
      "rank": "Rütbe",
      "searchValue": "Arama Değeri",
      "typeHere": "Buraya yaz",
      "searching": "Aranıyor...",
      "fetchingResult": "Sonuçlar getiriliyor... Lütfen bekleyin",
      "animalsMatchedYourCriteria": "Kriterlerinize Uygun Hayvanlar",
      "manageAnimalsGrouping": "Hayvanları Gruplandırmayı Yönet",
      "manageAnimalGroupings": "Hayvan Gruplarını Yönet",
      "assignAnimalToContemporaryGroups": "Çağdaş Gruplara Hayvan Ata",
      "resetMode": "Sıfırlama Modu",
      "enterResetMode": "Sıfırlama Moduna Girin",
      "maintainanceMode": "Bakım Modu",
      "assigningAnimals": "Hayvanları Atama",
      "excludedAnimals": "Hariç Tutulan Hayvanlar",
      "ungroupedAnimals": "Gruplanmamış Hayvanlar",
      "assignAnimalsToCGS": "Hayvanları CGS'ye Ata",
      "reset": "Sıfırla",
      "excludeAnimals": "Hayvanları Hariç Tut",
      "resetToMaintainanceMode": "Sıfırlama Tamamlandı - Bakım Moduna Geç",
      "contemporaryGroupsSettings": "Çağdaş Gruplar(CG) Ayarları",
      "selectTrait": "Özellik Seç",
      "selectTraitDescription": "Özellik Seçme, belirli bir özelliği seçme sürecini ifade eder",
      "traitsType": {
        "birthWeight": "Doğum ağırlığı",
        "weaningWeight": "Sütten Kesme Ağırlığı",
        "yearlingWeight": "Bir yıllık ağırlık",
        "carcassWeight": "Karkas Ağırlığı"
      },
      "addNewGroup": "YENİ GRUP EKLE",
      "contemporaryGroup": "Çağdaş Grup",
      "contemporaryGroups": "Çağdaş Gruplar",
      "editGroup": "Grubu Düzenle",
      "birthCGCode": "Doğum(CG) Kodu",
      "groupName": "Grup ismi",
      "birthSex": "doğum cinsiyeti",
      "conceptionMethod": "Gebelik Yöntemi",
      "weaningCGCode": "Sütten Kesme(CG) Kodu",
      "yearlingCGCode": "Toklu(CG) Kodu",
      "dateWeight": "Tarih Ağırlık",
      "weaningyearlingCGcode": "Sütten Kesme/Yaşlanma(CG) Kodu",
      "carcassCGCode": "Karkas(CG) Kodu",
      "breedOfDom": "Barajın Cinsi",
      "addNewContemporaryGroup": "Yeni Çağdaş Grup Ekle",
      "createNewGroup": "yeni Grup Oluştur",
      "selectFromDifferentTraits": "Farklı özellikler arasından seçim yapın",
      "contemporaryGroupName": "Çağdaş Grup Adı",
      "enterNameHere": "Buraya isim gir",
      "groupNameIsRequired": "Grup Adı gerekli",
      "birthYearRange": "Doğum Yılı Aralığı",
      "theYearAnimalWasBorn": "Hayvanın doğduğu yıl",
      "birthYearIsRequired": "Doğum Yılı gereklidir",
      "genderOfNewBornAnimal": "Yeni doğan hayvanın cinsiyeti",
      "selectSex": "Cinsiyet Seç",
      "theweightOfAnimalAtBirth": "Hayvanın doğumdaki ağırlığı",
      "maximumKg": "Maksimum",
      "minimumKg": "Asgari",
      "aSeasonisAPeriodOfYear": "Mevsim, özel iklim koşulları ile ayırt edilen yılın bir dönemidir.",
      "seasonofBirthIsRequired": "Doğum Mevsimi gereklidir",
      "majorGenericContributionOfAnimal": "Hayvanın Büyük % Jenerik Katkısı",
      "primaryBreedCompostionIsRequired": "Birincil Irk Bileşimi gereklidir",
      "secondaryBreedCompostionIsRequired": "İkincil Irk Bileşimi gereklidir",
      "howTheAnimalWasConceived": "Hayvanın gebe kalma şekli (doğal çiftleşme/döllenme/embriyo transferi)",
      "conceptionMethodIsRequired": "Gebelik Yöntemi gerekli",
      "epdModelSettings": "EPD Modeli Ayarları",
      "forResetMode": "Sıfırlama Modu için",
      "progenyWeightingFactor": "Döl Ağırlıklandırma Faktörü",
      "weightGivenToTheProgenyFactor": "Sıfırlama modunda EPD hesaplaması için CG faktörüne göre nesil faktörüne verilen ağırlık. ",
      "enterNumber": "Numarayı Girin",
      "enterBreed": "Irk girin",
      "valueShouldBeBetween0and1": "Değer 0 ile 1 arasında olmalıdır",
      "resetDuration": "Süreyi Sıfırla",
      "timeIntervalBetweenLastAndFirstResetMode": "Son ve yeni sıfırlama modu arasındaki, sonunda yeni sıfırlama modunun etkinleştirildiği ve yeni CG'lerin ve EPD'lerin hesaplandığı zaman aralığı.",
      "enterNumberOfDays": "Gün Sayısı Girin",
      "valueCannotBeNegative": "Değer negatif olamaz!",
      "criticalProgenyPopulation": "Kritik Döl Popülasyonu",
      "minimumNumberOfProgenyRecords": "Döl Doğruluğunu (APD1) %50'nin üzerinde elde etmek için sistemdeki bireysel hayvanın minimum soy kaydı sayısı (Pedigree Doğruluğu için)",
      "criticalAncestorPopulation": "Kritik Ata Nüfusu",
      "minimumNumberOfAncestorsRecords": "Ata Doğruluğunu (APD4) %50'nin üzerinde (Pedigri Doğruluğu için) elde etmek için sistemdeki bireysel hayvanın minimum ata kaydı sayısı",
      "forBirthWeightCG": "Doğum Ağırlığı CG için",
      "criticalPopulationInAnimalsContemporaryGroup": "Hayvanın Çağdaş Grubunda Kritik Popülasyon",
      "minimumAverageNumberOfAnimalsPerBirthWeight": "Ortalama CG Doğruluğunu (ACG3) %50'nin üzerinde elde etmek için gereken Doğum ağırlığı CG başına minimum ortalama hayvan sayısı",
      "criticalAveragePopulationPerContemporaryGroup": "Çağdaş Grup Başına Kritik Ortalama Nüfus",
      "minimumNumberOfAnimalsInBirthWeight": "%50'nin üzerinde CG Doğruluğuna (ACG2) ulaşmak için hayvanın Doğum ağırlığı CG'sindeki minimum hayvan sayısı",
      "forWeaningWeightCG": "Sütten Kesme Ağırlığı CG için",
      "minimumAverageNumberOfAnimalsPerWeaningWeight": "%50'nin üzerinde Ortalama CG Doğruluğuna (ACG3) ulaşmak için gerekli olan Sütten Kesme ağırlığı CG başına minimum ortalama hayvan sayısı",
      "minimumNumberOfAnimalsInWeaningWeight": "%50'nin üzerinde CG Doğruluğuna (ACG2) ulaşmak için hayvanın Sütten Kesme ağırlığı CG'sinde gereken minimum hayvan sayısı",
      "forYearlingWeightCG": "Toklu Ağırlık CG için",
      "minimumAverageNumberOfAnimalsPerYearling": "%50'nin üzerinde Ortalama CG Doğruluğuna (ACG3) ulaşmak için gerekli olan, Yearling CG başına minimum ortalama hayvan sayısı",
      "minimumNumberOfAnimalsInYearlingWeight": "%50'nin üzerinde CG Doğruluğuna (ACG2) ulaşmak için hayvanın Tokludaki ağırlığı CG'sinde gerekli olan minimum hayvan sayısı",
      "forCarcassCG": "Karkas CG için",
      "minimumAverageNumberOfAnimalsPerCarcassWeight": "Ortalama CG Doğruluğunu (ACG3) %50'nin üzerinde elde etmek için Karkas ağırlığı CG başına gereken minimum ortalama hayvan sayısı",
      "minimumNumberOFAnimalInCarcassWeight": "%50'nin üzerinde CG Doğruluğuna (ACG2) ulaşmak için hayvanın Karkas ağırlığı CG'sinde gerekli olan minimum hayvan sayısı",
      "epdRequiredFieldSettings": "EPD Gerekli Alan Ayarları",
      "pleaseSelectRequiredFieldsForCompleteEPD": "Eksiksiz bir EPD hesaplaması için lütfen gerekli alanları seçin",
      "byDefault": "Varsayılan olarak",
      "pleaseNoteThatUsersNotAbleToObtainFullEPD": "Not: Gerekli olarak işaretlediğiniz veri alanlarını sağlamayan kullanıcıların tam EPD hesaplaması alamayacaklarını lütfen unutmayın.",
      "pleaseNoteThatRequiredFieldParametersCannotBeChanged": "Not: Gerekli alan parametrelerinin değiştirilemeyeceğini lütfen unutmayın çünkü önceki parametrelere karşı halihazırda güncel gruplar vardır.",
      "noResultFound": "SONUÇ BULUNAMADI",
      "next": "Sonraki",
      "cancel": "İptal etmek",
      "selectAnimal": "Hayvan Seç",
      "searchBy": "Ara",
      "breed": "Yavrulamak",
      "regDate": "Reg. ",
      "status": "Durum",
      "animalDetails": "Hayvan Detayları",
      "add": "Eklemek",
      "update": "Güncelleme",
      "dataForEPDs": " EPD'ler için veriler",
      "basicInformation": "Temel Bilgiler",
      "birthWeightInformation": "Doğum Ağırlığı Bilgileri",
      "weaningWeightInformation": "Sütten Kesme Ağırlık Bilgileri",
      "yearlingWeightInformation": "Toklu Ağırlık Bilgileri",
      "carcassWeightInformation": "Karkas Ağırlık Bilgileri",
      "delete": "Silmek",
      "deleteEpdData": "EPD Verilerini Sil",
      "areYouSureYouWantToDeleteEpdData": "EPD verilerini silmek istediğinizden emin misiniz?",
      "internationalID": "Uluslararası kimlik",
      "enterID": "Kimliği girin",
      "animalRegistration": "Hayvan Kaydı",
      "location": "Konum",
      "additionalIDMethod": "Ek Kimlik Yöntemi",
      "damID": "Baraj Kimliği",
      "sireID": "Efendi Kimliği",
      "breederHerdCode": "Damızlık Sürü Kodu",
      "birthYear": "doğum yılı",
      "primaryBreed": "Birincil Irk",
      "breedComposition": "Irk Kompozisyonu",
      "secondaryBreed": "İkincil Irk",
      "seasonofBirth": "Doğum Mevsimi",
      "birthManagementCode": "Doğum Yönetim Kodu",
      "damAge": "Zarar",
      "years": "yıl",
      "birthContemporaryCode": "Doğum Çağdaş Kodu",
      "accuracyWeight": "Doğruluk Ağırlık",
      "note": "Not",
      "minimumRequiredFieldForBirthWeight": "Doğum Ağırlığı EPD'leri için gerekli minimum alan",
      "birthYearGenderConceptionMethodBirthWeight": "Doğum Yılı , Cinsiyet , Gebelik Yöntemi , Doğum Ağırlığı",
      "weaningWeight": "Sütten Kesme Ağırlığı",
      "weaningDate": "Sütten Kesme Tarihi",
      "weaningContemporaryGroupCode": "Sütten Kesme Çağdaş Grup Kodu",
      "creep": "Sürünme",
      "managementPastureCode": "Yönetim/Mera Kodu",
      "weaningSex": "Sütten kesme Seks",
      "minimumRequiredFieldForWeaningWeight": "Weaning Weight EPD'leri için gerekli minimum alan",
      "weaningWeightManagementPastureCodeWeaningSexDateWeighed": "Sütten Kesme Ağırlığı , Yönetim/Mera Kodu , Sütten Kesme Cinsiyeti , Tartılma Tarihi",
      "yearlingWeight": "Bir yıllık ağırlık",
      "yearlingHeight": "toklu Yükseklik",
      "yearlingDate": "bir yaşındaki tarih",
      "yearlingContemporaryGroupCode": "Toklu Çağdaş Grup Kodu",
      "managementFeedingCode": "Yönetim/Besleme Kodu",
      "yearlingSex": "bir yaşındaki seks",
      "youWillNeedToFillOutFor": "EPD verilerini almak için tüm alanları doldurmanız gerekecektir.",
      "pleaseSelectHavestDateFirstToEnterInfo": "Kaburga Göz Bölgesi, Yağ Kalınlığı ve Ebru bilgilerini girmek için lütfen önce 'Hasat Tarihi'ni seçin.",
      "harvestDate": "Hasat Tarihi",
      "dateOnFeed": "Besleme Tarihi",
      "daysOnFeed": "Yem Günleri",
      "gradingDate": "Not Verme Tarihi",
      "carcassSex": "karkas seks",
      "carcassWeight": "Karkas Ağırlığı",
      "carcassContemporary": "Karkas Çağdaş",
      "damBreed": "Baraj Cinsi",
      "ribEyeArea": "Kaburga Göz Bölgesi",
      "ribEyeAreaContemporary": "Kaburga Gözü Alanı Çağdaş",
      "fatThickness": "Yağ Kalınlığı",
      "fatThicknessContemporary": "Yağ Kalınlığı Çağdaş",
      "marbling": "Ebru",
      "marblingContemporary": "Ebru Çağdaş",
      "yieldGradeContemporary": "Verim Derecesi Çağdaş",
      "animalsNotListedInContemporaryGroupsMsg": "Eksik bilgi nedeniyle hayvanlar herhangi bir çağdaş gruba eklenmemiştir. ",
      "listOfUngroupedAnimals": "Gruplanmamış Hayvanların Listesi",
      "submittingData": "Veri Gönderme",
      "resendToUser": "Kullanıcıya Yeniden Gönder",
      "submittingAnimalsInGroupMsg": "Hayvanlarınızı gruplara gönderme. ",
      "pressingResetBtnMsg": "\"Sıfırla\" düğmesine basmak, hayvanları çağdaş gruplarına yeniden atama sürecini başlatacaktır.",
      "doYouWantToProceed": "Devam etmek istiyor musunuz ?",
      "systemMaintainanceModeMsg": "\"Bakım Moduna Geç\" düğmesine bastığınızda bir işlem başlatılacak ve sisteminiz \"BAKIM MODU\"na girecek ve burada RESET'te hesaplanan EDP'ler bir sonraki RESET'e kadar (1-6 ay olabilir) her hayvan için sabit tutulacaktır. ",
      "errorFetchingContemporaryGrpMsg": "Çağdaş grup verileri alınırken hata oluştu",
      "deleteSuccess": "Başarıyı Sil",
      "deleteSuccessMsg": "Çağdaş grup başarıyla silindi.",
      "deleteFailed": "Silme Başarısız",
      "deleteFailedMsg": "Çağdaş grup verileri silinirken hata oluştu",
      "deleteContemporaryGrpMsg": "Bu çağdaş grubu silmek istediğinizden emin misiniz?",
      "addBirthWeightData": "Doğum Ağırlığı Verilerini Ekleyin",
      "addWeaningWeightData": "Sütten Kesme Ağırlığı Verilerini Ekle",
      "birthWeightContemporaryGroupCode": "Doğum Ağırlığı Çağdaş Grup Kodu",
      "dateWeighted": "Tarih ağırlıklı",
      "addYearlingWeightData": "Toklu Ağırlık Verilerini Ekle",
      "addCarcassWeightData": "Karkas Ağırlığı Verilerini Ekle",
      "weaningOrYearlingContemporaryGroupCode": "Sütten Kesme veya Bir Yaşındaki Ağırlık Çağdaş Grup Kodu",
      "deleteContemporaryGroupMsg": "Çağdaş grubu silmek istediğinizden emin misiniz?",
      "updateSuccessMsg": "Çağdaş grup başarıyla güncellendi.",
      "errorMsg": "Bir şeyler yanlış gitti. ",
      "fetchErrorMsg": "Seçilen özellik için gerekli alanlar getirilirken hata oluştu.",
      "forMaintainanceMode": "Bakım Modu için",
      "ancestorsWeightFactor": "Atalar Ağırlık Faktörü",
      "weightGivenToTheAncestorFactor": "Bakım modunda EPD hesaplaması için CG faktörüne göre ata faktörüne verilen ağırlık. ",
      "addEPDModelSettingsData": "EPD Model Ayarları Verilerini Ekle",
      "minimumNumberOfAnimalsInContemporaryGroups": "Çağdaş Gruplarda Minimum Hayvan Sayısı",
      "enterNumberOfAnimals": "Hayvan Sayısını Girin",
      "areYouSureYouWantToChangeEPDCalculation": "Gerekli EPD hesaplama alanlarını değiştirmek istediğinizden emin misiniz?",
      "weightOfAnimalAtBirth": "Hayvanın Doğumdaki Ağırlığı",
      "seasonIsAPeriodOfYear": "Mevsim, özel iklim koşulları ile ayırt edilen yılın bir dönemidir.",
      "codeOfBirthWeightContemporaryGroup": "Doğum Ağırlığı Çağdaş Grubunun Kodu",
      "weaningWeightOfCalf": "Buzağı Sütten Kesme Ağırlığı",
      "dateAnimalWasWeaned": "Hayvanın sütten kesildiği tarih",
      "genderOfWeaningAnimal": "Sütten Kesilen Hayvanın Cinsiyeti",
      "yearlingWeightOfCalf": "Buzağının Bir Yıllık Ağırlığı",
      "dateAnimalWasWeighted": "Hayvanın tartıldığı tarih",
      "yearledAnimalSex": "Yıldırılan hayvanın cinsiyeti",
      "dateOfAnimalKilledForMeat": "Eti için öldürülen hayvanın tarihi",
      "addSuccessMsg": "Çağdaş grup başarıyla eklendi",
      "traitH": "EPD hesaplaması için özellik.",
      "searchByValue": "Kayıt No/Dövme/İsim/Etiket Girin"
    }
  }